// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:14.116Z
// Property: Chisholm Pointe (ID: 6767906449165593)
// Collections: 22 amenities, 7 floorplans (live), 41 photos, 87 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165593",
  "property_external_id": "yjm8m0t",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/chisholm-pointe/CgzSSK/",
  "property_apartments_url": "https://www.apartments.com/chisholm-pointe-oklahoma-city-ok/yjm8m0t/",
  "property_google_business_url": "https://www.google.com/maps/place/Chisholm+Pointe/data=!4m2!3m1!1s0x0:0x48111ff0ec0115c5?sa=X&ved=2ahUKEwi0hoba9LySAxVhm2oFHdVCHoIQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chisholm-pointe",
  "property_name": "Chisholm Pointe",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/chisholm-pointe/",
  "property_domain": null,
  "property_address": "1721 NW 115th",
  "property_full_address": "1721 NW 115th, Oklahoma City, OK, 73120",
  "property_address_1": "1721 NW 115th",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73120",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.5869",
  "property_address_longitude": "-97.5444",
  "property_email": "chisholmpointe@caseusa.com",
  "property_phone": "(405) 645-6515",
  "property_call_tracking_phone": "833-341-2975",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Chisholm Pointe in vibrant Oklahoma City, where modern living meets serene outdoor escapes. Choose from our stylish one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a resort-style swimming pool, fire pits, and a dog park. Experience comfortable living tailored to you—explore your future home today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Chisholm Pointe, an exceptional apartment community located in the heart of Oklahoma City, Oklahoma! With an array of thoughtfully designed floor plans, including one, two, and three-bedroom units, you'll find the perfect space to call home. Each apartment is equipped with energy-efficient stainless appliances, wood-style flooring, and spacious walk-in closets, offering both comfort and style.\n\nAt Chisholm Pointe, we believe in creating a lifestyle that extends beyond your front door. Our impressive amenities include resort-style swimming pools for relaxation, outdoor living areas perfect for gatherings, and a cozy fire pit to enjoy those starry Oklahoma nights. For our furry residents, an onsite dog park provides a safe space to play and socialize.\n\nExperience convenience with features such as controlled access gates, package receiving, and online rental payments, ensuring peace of mind and hassle-free living. Our clubhouse is ideal for socializing, while our pickleball court offers a fun way to stay active. Select units also come with private garages, preinstalled WiFi modems powered by Cox, full-size or stackable washer and dryer connections, and central heating and air to keep you comfortable year-round.\n\nAt Chisholm Pointe, our on-site management team is dedicated to providing excellent service and support, ensuring that you feel right at home in our vibrant community. \n\nDon't wait—find your new home today! Browse our availability or schedule a tour to visit our welcoming community at Chisholm Pointe!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019fb44b-3087-755f-ad09-52b5126369b2.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and clubhouse at a multifamily property",
    "public_id": "019fb44b-3087-755f-ad09-52b5126369b2",
    "storage_key": "property/6767906449165593/019fb44b-3087-755f-ad09-52b5126369b2.webp",
    "width": 1280,
    "height": 852
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "216",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.44444444444444",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "300-650",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Maximum of two pets allowed. Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pet rent $30 per pet per month. $500 non‑refundable fee per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://chisholmpointeokc.securecafe.com/onlineleasing/chisholm-pointe/floorplans.aspx",
  "property_resident_portal_url": "https://chisholmpointeokc.securecafenet.com/residentservices/chisholm-pointe/userlogin",
  "property_apply_now_url": "https://chisholmpointeokc.securecafe.com/onlineleasing/chisholm-pointe/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-802f-77e1-8046-e507fd4e26af.webp",
  "property_primary_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logos",
    "public_id": "019cfb3b-802f-77e1-8046-e507fd4e26af",
    "storage_key": "property/6767906449165593/019cfb3b-802f-77e1-8046-e507fd4e26af.webp",
    "width": 998,
    "height": 313
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3d-1b4c-7539-b20b-f13dc5508acc.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3d-1b4c-7539-b20b-f13dc5508acc",
    "storage_key": "property/6767906449165593/019cfb3d-1b4c-7539-b20b-f13dc5508acc.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-802f-77e1-8046-e507fd4e26af.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logos",
    "public_id": "019cfb3b-802f-77e1-8046-e507fd4e26af",
    "storage_key": "property/6767906449165593/019cfb3b-802f-77e1-8046-e507fd4e26af.webp",
    "width": 998,
    "height": 313
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3d-35c4-76eb-8380-42d554104de7.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logos.",
    "public_id": "019cfb3d-35c4-76eb-8380-42d554104de7",
    "storage_key": "property/6767906449165593/019cfb3d-35c4-76eb-8380-42d554104de7.webp",
    "width": 640,
    "height": 201
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "683 - 1355",
  "property_sqft_min": "683",
  "property_sqft_max": "1355",
  "property_price_range": "1390 - 2000",
  "property_price_min": "1390",
  "property_price_max": "2000",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/ChisholmPointe/posts/-say-hello-to-your-new-home-at-chisholm-pointe-in-oklahoma-city-choose-from-spac/122261354618067700/",
  "property_instagram_url": "https://www.instagram.com/chisholmpointeokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ83kQUokbsocRxRUB7PAfEUg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/chisholm-pointe-oklahoma-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chisholm Pointe",
  "property_home_romance_title": "Embrace Life at Your Perfect Apartment Community Today",
  "property_home_amenities_blurb": "At Chisholm Pointe in Oklahoma City, experience vibrant living in thoughtfully designed one, two, and three-bedroom apartments. Enjoy modern amenities like resort-style pools, outdoor fire pits, and a welcoming clubhouse. Embrace community and comfort with energy-efficient appliances, spacious walk-in closets, and an onsite dog park—your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to Chisholm Pointe in vibrant Oklahoma City, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom apartments that cater to your lifestyle. Each space offers the perfect blend of luxury and convenience. Browse our available homes today and find your ideal floor plan!",
  "property_home_gallery_blurb": "Welcome to Chisholm Pointe in Oklahoma City, where modern living meets vibrant community life. Choose from our thoughtfully designed one, two, or three-bedroom apartments, and indulge in resort-style amenities like a sparkling pool, outdoor fire pit, and an onsite dog park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Chisholm Pointe in Oklahoma City, your home is nestled among vibrant community gems. Enjoy easy access to the Oklahoma City Zoo, Science Museum Oklahoma, and beautiful outdoor spaces like Martin Park Nature Center. With diverse two, one, and three-bedroom floor plans, life at Chisholm Pointe harmonizes comfort and excitement.",
  "property_home_reviews_blurb": "At Chisholm Pointe in Oklahoma City, residents rave about the community's beautiful landscaping and responsive management team. With various floor plans and exceptional amenities like pickleball courts and dog parks, it's no wonder families find a peaceful vibe here. “We recommend Chisholm Pointe without reservation.” Join us today!",
  "property_neighborhood_blurb": "At Chisholm Pointe in Oklahoma City, your lifestyle thrives amidst a wealth of attractions. Unwind at the serene Martin Park Nature Center or delve into local history at the National Cowboy & Western Heritage Museum. With vibrant venues like the Oklahoma City Zoo and expansive parks nearby, adventure awaits! ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chisholm Pointe in Oklahoma City, indulge in a lifestyle filled with exceptional comforts. Enjoy resort-style amenities like a sparkling swimming pool, outdoor lounges, and a fun pickleball court. With energy-efficient appliances and spacious layouts, your perfect apartment awaits—step into luxury today and experience the unique charm of our community.",
  "property_applynow_blurb": "At Chisholm Pointe in Oklahoma City, vibrant living awaits. Choose from spacious one, two, or three-bedroom floor plans, featuring wood-style flooring and energy-efficient appliances. Enjoy resort-style amenities like a sparkling pool, outdoor fire pit, and onsite dog park. Experience the perfect blend of comfort and community—lease your new home today!",
  "property_contactus_blurb": "At Chisholm Pointe in vibrant Oklahoma City, our thoughtfully designed floor plans cater to every need. Choose from stylish one, two, or three-bedroom apartments, each crafted for comfort and convenience. Have questions? Reach out to our friendly leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Chisholm Pointe in Oklahoma City, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page is your go-to resource, providing clear answers about our community, amenities, and more. Delve in to learn how we can elevate your living experience!",
  "property_floorplans_blurb": "At Chisholm Pointe in Oklahoma City, your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort and style. Each layout complements your lifestyle, ensuring you feel right at home. Browse our available apartment homes to find your perfect fit today!",
  "property_gallery_blurb": "At Chisholm Pointe in Oklahoma City, vibrant living meets convenience. Envision relaxing in our resort-style pool, grilling with friends at the fire pit, or playing pickleball in your downtime. With spacious two, one, and three-bedroom floor plans, paired with premium amenities, picture your dream lifestyle—just a click away!",
  "property_interactivemap_blurb": "At Chisholm Pointe in Oklahoma City, choose from one, two, or three-bedroom apartments that blend comfort and modern living. Enjoy resort-style amenities—from tranquil outdoor living spaces with fire pits to an energizing pickleball court. Ready to find your ideal home? Browse our interactive community map for available options!",
  "property_pets_blurb": "At Chisholm Pointe in Oklahoma City, we believe your furry friends deserve a home too! With no weight limit and space for up to two pets, your beloved companions can enjoy life by your side. Embrace vibrant living in a community that caters to both you and your pets.",
  "property_referafriend_blurb": "At Chisholm Pointe in Oklahoma City, we offer spacious one, two, and three-bedroom floor plans tailored for comfort and style. Share the experience with a friend – great friends make the best neighbors! Refer a friend today and embark on a delightful journey of community living together. ",
  "property_residentaccess_blurb": "Welcome to Chisholm Pointe, where your perfect home awaits in vibrant Oklahoma City! Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Ready to enhance your living experience? Access your resident portal to conveniently pay rent, schedule maintenance, and embrace a community that feels like home!",
  "property_reviews_blurb": "At Chisholm Pointe in Oklahoma City, residents rave about the community's outstanding management and beautiful surroundings, describing it as \"an awesome place to live.\" With diverse floor plans, friendly neighbors, and amenities like two dog parks, it's the perfect blend of comfort and convenience. Experience the pride of calling Chisholm Pointe home!",
  "property_created_at": "1753982380314",
  "property_scheduletour_blurb": "At Chisholm Pointe in Oklahoma City, a variety of thoughtfully designed floor plans await you, from cozy one-bedroom retreats to spacious three-bedroom homes. Schedule a tour today and hear firsthand how our vibrant community transforms everyday living into extraordinary experiences. Your ideal home is just a visit away!",
  "property_thankyou_blurb": "Thank you for sharing your information with Chisholm Pointe! Nestled in vibrant Oklahoma City, our thoughtfully designed floor plans offer one, two, and three-bedroom options to suit your lifestyle. We're excited to connect you with your dream home—stay tuned for a member of our team to reach out soon!",
  "property_virtualtours_blurb": "Experience the charm of Chisholm Pointe in Oklahoma City, where spacious one, two, and three-bedroom apartments await your personal touch. Enjoy modern living in a vibrant community setting. Ready to envision your future home? Take a virtual tour today and see why Chisholm Pointe is the perfect place to settle down!",
  "property_copyright": "2025 All Rights Reserved. Chisholm Pointe",
  "property_seo_title_home": "Chisholm Pointe |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Unwind at Chisholm Pointe in Oklahoma City—where stylish living meets resort-style amenities! Choose from 1 to 3 bedroom homes and enjoy luxury at its finest.",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Chisholm Pointe in Oklahoma City! Browse our spacious one, two, and three-bedroom floor plans tailored for modern living.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Chisholm Pointe in Oklahoma City! Enjoy upscale amenities like a resort pool, outdoor living spaces, and dog parks. Your home awaits you!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Picture life at Chisholm Pointe in OKC! Embrace luxury with resort-style amenities, spacious floor plans, and vibrant outdoor living—your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Chisholm Pointe Apartments",
  "property_seo_description_virtualtours": "Experience luxury living in Oklahoma City at Chisholm Pointe! Take a virtual tour and see our stylish one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Chisholm Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Chisholm Pointe, Oklahoma City! Explore spacious floor plans and amenities with our interactive map. Your perfect space awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Discover your ideal lifestyle at Chisholm Pointe in OKC. Explore local gems and vibrant spots right at your doorstep!",
  "property_seo_title_contact": "Contact Us | Chisholm Pointe",
  "property_seo_description_contact": "Discover Chisholm Pointe in OKC! Explore our one to three-bedroom floor plans. Questions? Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Chisholm Pointe in Oklahoma City! Discover amenities like a resort-style pool, dog park, and energy-efficient living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience the vibrant community at Chisholm Pointe in Oklahoma City. Read resident reviews and see why our spacious homes and top-notch amenities shine!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at Chisholm Pointe in Oklahoma City! Choose from spacious floor plans and enjoy top-notch amenities. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Chisholm Pointe",
  "property_seo_description_residentaccess": "Log in to Chisholm Pointe's resident portal for effortless rent payments, maintenance requests, and community updates. Your convenience starts here!",
  "property_seo_title_referafriend": "Refer A Friend | Chisholm Pointe",
  "property_seo_description_referafriend": "Share the love! Refer a friend to Chisholm Pointe in Oklahoma City and build a thriving community together. Great friends make great neighbors—join us!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chisholm Pointe",
  "property_seo_description_scheduletour": "Experience modern living at Chisholm Pointe in Oklahoma City. Enjoy spacious apartments and vibrant amenities. Schedule your tour today and feel at home!",
  "property_seo_title_privacy": "Privacy Policy | Chisholm Pointe",
  "property_seo_description_privacy": "Your privacy matters at Chisholm Pointe in Oklahoma City. Uncover our commitment to safeguarding your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Chisholm Pointe",
  "property_seo_description_accessibility": "At Chisholm Pointe in Oklahoma City, we prioritize digital accessibility for everyone. Join our community where inclusivity meets comfort and convenience.",
  "property_seo_title_sitemap": "Sitemap | Chisholm Pointe",
  "property_seo_description_sitemap": "Navigate Chisholm Pointe's fully-connected community in Oklahoma City with ease. Check out our sitemap now for a glimpse of your future home!",
  "property_seo_title_thankyou": "Thank You | Chisholm Pointe",
  "property_seo_description_thankyou": "Thank you for your interest in Chisholm Pointe! A team member will connect with you soon to help you find your perfect home in vibrant Oklahoma City.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864986090",
  "amenities": [
    {
      "id": "ec_8e85b6483ad50a04d659935d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127864031",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf23f2d3fac870cdf729dff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127864028",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_108cbceac2549abb3cd40a46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396354",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_357b10182b22d13f02ab591e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396355",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e5a96da2b1b9950016f93b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396356",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d5f67c63ac71fba299b058b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396357",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58a9eaa998616c72929610b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396359",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c6eb36b714ffd69a8b1dead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396360",
      "title": "Resort Style Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c3c151cec40ec4f3c1903c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396361",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7512123aca1d17f114a9ab30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396362",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_546f510cd0a72f9eeeddc426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127396363",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3e6a60348d4714bc90efe97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "128018922",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43993d6d11e44c3803025048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127864035",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35e0f4a2d2240e1210420c15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127864033",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_123a0b450ac22a7ab18bd6be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397856",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a536add1fe6b08c217856236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397857",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8db47e8ad3eab04b869f94c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397859",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f056484c375eb94b85968db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397860",
      "title": "Full-Size or Stackable Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_609f0ce62d0f816c85a19988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397861",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c69fce354ce497860ab20abd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397862",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a765d6486405bcf27c0038d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397863",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9a9e8865e8fb761f3a7da2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "yardi",
      "external_id": "127397864",
      "title": "Fenced Yards",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2d03c5ea-5455-4989-93c8-b1240efb5e5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-710c-7228-a150-2b8d1b1c367f.webp",
      "image_media": {
        "alt_text": "Exterior of a teal-colored apartment building with brick accents and a wooden fence.",
        "public_id": "019f70d2-710c-7228-a150-2b8d1b1c367f",
        "storage_key": "property/6767906449165593/019f70d2-710c-7228-a150-2b8d1b1c367f.webp",
        "width": 2636,
        "height": 1758
      },
      "title": "Community",
      "description": "View of a beautifully landscaped apartment building exterior, showcasing its modern design and welcoming facade.",
      "link": "",
      "alt_text": "Exterior of a teal-colored apartment building with brick accents and a wooden fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_748e50eb-ab44-43b1-afa5-b1c9bcb16e5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-71b2-7495-8c9d-2c7bf46d8d4a.webp",
      "image_media": {
        "alt_text": "Exterior of a teal-colored apartment building with brick accents and landscaping.",
        "public_id": "019f70d2-71b2-7495-8c9d-2c7bf46d8d4a",
        "storage_key": "property/6767906449165593/019f70d2-71b2-7495-8c9d-2c7bf46d8d4a.webp",
        "width": 2445,
        "height": 1630
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building featuring a welcoming teal facade, brick detailing, and lush landscaping, creating an inviting community atmosphere.",
      "link": "",
      "alt_text": "Exterior of a teal-colored apartment building with brick accents and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0faaa61f-b2f1-4377-9ae3-e393bcbf8d76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-5fda-738d-b75c-40ac722326fa.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property featuring rows of houses, a swimming pool, and a clubhouse.",
        "public_id": "019f70d2-5fda-738d-b75c-40ac722326fa",
        "storage_key": "property/6767906449165593/019f70d2-5fda-738d-b75c-40ac722326fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our beautiful multifamily community from an aerial perspective. Featuring modern homes, a sparkling swimming pool, and a welcoming clubhouse.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property featuring rows of houses, a swimming pool, and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f945086-0888-456e-a8db-31f8a21332c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-5a85-71be-969d-f767c4a28084.webp",
      "image_media": {
        "alt_text": "Fitness center with cable machine, free weights, kettlebells, medicine balls, and treadmills.",
        "public_id": "019f70d2-5a85-71be-969d-f767c4a28084",
        "storage_key": "property/6767906449165593/019f70d2-5a85-71be-969d-f767c4a28084.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a wide range of cardio and strength training equipment to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with cable machine, free weights, kettlebells, medicine balls, and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c3a032e-ccb8-490b-b632-f141ae8af0f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-59a1-7578-8fcc-0b806af9ee17.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in the apartment gym.",
        "public_id": "019f70d2-59a1-7578-8fcc-0b806af9ee17",
        "storage_key": "property/6767906449165593/019f70d2-59a1-7578-8fcc-0b806af9ee17.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring modern cardio equipment for a great workout.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in the apartment gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d67e0c91-a65c-42e2-bca8-ae517fd22e5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-3a0e-75ae-b68f-ac8ad20b8a32.webp",
      "image_media": {
        "alt_text": "Exterior of a white multifamily building with a symmetrical entrance and two windows on each side, set against a blue sky with clouds.",
        "public_id": "019f70d2-3a0e-75ae-b68f-ac8ad20b8a32",
        "storage_key": "property/6767906449165593/019f70d2-3a0e-75ae-b68f-ac8ad20b8a32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior view of a multifamily property, showcasing a clean white facade, traditional brick accents, and a well-maintained parking area under a bright, cloudy sky.",
      "link": "",
      "alt_text": "Exterior of a white multifamily building with a symmetrical entrance and two windows on each side, set against a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_098c9d42-6816-4133-91ac-c9da8c0a0dca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-a077-774f-ac4e-86b4a41be8ef.webp",
      "image_media": {
        "alt_text": "Modern living room with a burnt orange sofa, decorative pillows, and a coffee table.",
        "public_id": "019f70d1-a077-774f-ac4e-86b4a41be8ef",
        "storage_key": "property/6767906449165593/019f70d1-a077-774f-ac4e-86b4a41be8ef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, accent chairs, and contemporary decor, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a burnt orange sofa, decorative pillows, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9265475c-fe3f-49b0-a34c-7eb07d01408e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-99dc-7517-b444-824879102a3f.webp",
      "image_media": {
        "alt_text": "Front porch with two chairs and a small table, facing the building entrance.",
        "public_id": "019f70d1-99dc-7517-b444-824879102a3f",
        "storage_key": "property/6767906449165593/019f70d1-99dc-7517-b444-824879102a3f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on your private front porch, complete with comfortable seating and a welcoming entrance.",
      "link": "",
      "alt_text": "Front porch with two chairs and a small table, facing the building entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a695c0db-b897-4bed-87af-6962f421eba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-95bf-733b-8255-a1722bd7735a.webp",
      "image_media": {
        "alt_text": "Private patio with artificial turf and a chair",
        "public_id": "019f70d1-95bf-733b-8255-a1722bd7735a",
        "storage_key": "property/6767906449165593/019f70d1-95bf-733b-8255-a1722bd7735a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy your own private outdoor space with a patio featuring artificial turf and comfortable seating.",
      "link": "",
      "alt_text": "Private patio with artificial turf and a chair",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4c3bb22-6e09-4c0d-bf5f-be9e11504b61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-7af4-753e-b271-8284fe359580.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a white island with two bar stools.",
        "public_id": "019f70d1-7af4-753e-b271-8284fe359580",
        "storage_key": "property/6767906449165593/019f70d1-7af4-753e-b271-8284fe359580.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, ample cabinet space, and a sleek island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a white island with two bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0c834ab-f8c8-4faa-8c19-6da35efc1a37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-68a1-71df-8c37-f368f85efff0.webp",
      "image_media": {
        "alt_text": "A bright bedroom with a queen-size bed, yellow bedding, and a dresser.",
        "public_id": "019f70d1-68a1-71df-8c37-f368f85efff0",
        "storage_key": "property/6767906449165593/019f70d1-68a1-71df-8c37-f368f85efff0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and inviting bedroom featuring a comfortable queen-size bed with plush yellow bedding, nightstands, and a spacious dresser. The room is illuminated by natural light and features modern decor.",
      "link": "",
      "alt_text": "A bright bedroom with a queen-size bed, yellow bedding, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62484ae9-a5c1-4eb2-a898-819cfa5bf592",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-6c22-721e-8b9b-eb892d4c6a1b.webp",
      "image_media": {
        "alt_text": "Charming front porch with two chairs, a small table, and a welcome mat.",
        "public_id": "019f70d1-6c22-721e-8b9b-eb892d4c6a1b",
        "storage_key": "property/6767906449165593/019f70d1-6c22-721e-8b9b-eb892d4c6a1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the fresh air on your private front porch, perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Charming front porch with two chairs, a small table, and a welcome mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd5d0ae8-b1ec-414a-9bc0-4b47c4ca539b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-6bd0-70c8-82a7-c7df8629142e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a large sectional sofa, TV, and island.",
        "public_id": "019f70d1-6bd0-70c8-82a7-c7df8629142e",
        "storage_key": "property/6767906449165593/019f70d1-6bd0-70c8-82a7-c7df8629142e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen featuring a sectional sofa, entertainment center, and kitchen island, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with a large sectional sofa, TV, and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_132e79ac-e227-44f9-bc1c-78351a5cccef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-6768-71e7-92b4-32167fcaddae.webp",
      "image_media": {
        "alt_text": "Empty laundry room with hookups and a closet rod.",
        "public_id": "019f70d1-6768-71e7-92b4-32167fcaddae",
        "storage_key": "property/6767906449165593/019f70d1-6768-71e7-92b4-32167fcaddae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty laundry room features hookups for a washer and dryer, as well as a convenient closet rod for storage.",
      "link": "",
      "alt_text": "Empty laundry room with hookups and a closet rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_445330c8-1461-4cf5-aa60-2eba7600992b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-49d9-7575-900a-cda6236e7b5f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and gray cabinets.",
        "public_id": "019f70d1-49d9-7575-900a-cda6236e7b5f",
        "storage_key": "property/6767906449165593/019f70d1-49d9-7575-900a-cda6236e7b5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample counter space, and stylish gray cabinetry. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f35e91a-2af4-4777-a076-4b4b7fdcdbd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-4dc9-762e-a11a-9335e83af35d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower with patterned shower curtain.",
        "public_id": "019f70d1-4dc9-762e-a11a-9335e83af35d",
        "storage_key": "property/6767906449165593/019f70d1-4dc9-762e-a11a-9335e83af35d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and modern bathroom featuring a spacious vanity with a sink, a toilet, and a tub/shower combo with a stylish patterned shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower with patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2eeff27-5294-43d7-8dde-44774da0b30e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-4798-737a-809d-9f87fefd52b0.webp",
      "image_media": {
        "alt_text": "Stylish bathroom with vanity, toilet, and shower with marble-look tiles.",
        "public_id": "019f70d1-4798-737a-809d-9f87fefd52b0",
        "storage_key": "property/6767906449165593/019f70d1-4798-737a-809d-9f87fefd52b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern and chic bathroom featuring a spacious vanity, a clean white toilet, and a bathtub/shower combination with elegant marble-look tilework.",
      "link": "",
      "alt_text": "Stylish bathroom with vanity, toilet, and shower with marble-look tiles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3efbb07-20fd-4b7a-a958-3fad29d08946",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-2445-73c8-9671-a35d379e2ff7.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, blue bedding, and a light blue throw blanket.",
        "public_id": "019f70d1-2445-73c8-9671-a35d379e2ff7",
        "storage_key": "property/6767906449165593/019f70d1-2445-73c8-9671-a35d379e2ff7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with deep blue bedding and a textured light blue throw blanket, complemented by stylish wall art and a comfortable armchair.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, blue bedding, and a light blue throw blanket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61547b4f-2f60-4ec0-ad66-c82f2d244dfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-2119-71bb-b961-93a68b20247b.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sofa, TV, armchair, and decorative plants.",
        "public_id": "019f70d1-2119-71bb-b961-93a68b20247b",
        "storage_key": "property/6767906449165593/019f70d1-2119-71bb-b961-93a68b20247b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, perfect for relaxing or entertaining guests. Features a large sofa, entertainment center, and chic decor.",
      "link": "",
      "alt_text": "Modern living room with a large sofa, TV, armchair, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d85c1d80-86e2-42fb-9839-33c713acc7fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-238d-75dd-81a7-4f5bf8c86cb4.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, next to a stainless steel refrigerator.",
        "public_id": "019f70d1-238d-75dd-81a7-4f5bf8c86cb4",
        "storage_key": "property/6767906449165593/019f70d1-238d-75dd-81a7-4f5bf8c86cb4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table with comfortable chairs, adjacent to a modern stainless steel refrigerator, perfect for everyday meals.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, next to a stainless steel refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d94a61b-b4b0-45fe-82d3-4aaf42112c6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-015d-715c-ab9f-1e03f0112416.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sectional sofa, accent chair, and TV stand.",
        "public_id": "019f70d1-015d-715c-ab9f-1e03f0112416",
        "storage_key": "property/6767906449165593/019f70d1-015d-715c-ab9f-1e03f0112416.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern comfort in this beautifully appointed living room, featuring a plush sectional, unique accent chair, and a sleek entertainment center. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Stylish living room with a sectional sofa, accent chair, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87e0710f-c2b1-4306-8c9c-90a1b6a6b30f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-d873-715b-9730-a7dbeb139b42.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, white quartz countertops, and bar seating.",
        "public_id": "019f70d0-d873-715b-9730-a7dbeb139b42",
        "storage_key": "property/6767906449165593/019f70d0-d873-715b-9730-a7dbeb139b42.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring stainless steel appliances, ample cabinet space, a breakfast bar with seating, and chic decor.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, white quartz countertops, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e137d44c-e896-4f4b-9c54-fb7992741f29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-b2f2-7475-abec-48a5955807bd.webp",
      "image_media": {
        "alt_text": "Private backyard with a wooden fence and green grass.",
        "public_id": "019f70d0-b2f2-7475-abec-48a5955807bd",
        "storage_key": "property/6767906449165593/019f70d0-b2f2-7475-abec-48a5955807bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy your own private outdoor space with a fenced backyard, perfect for pets or relaxation.",
      "link": "",
      "alt_text": "Private backyard with a wooden fence and green grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_703d5277-3797-415d-984f-398ee6e33da2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-99bf-777f-8c3e-583f4e9ad942.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
        "public_id": "019f70d0-99bf-777f-8c3e-583f4e9ad942",
        "storage_key": "property/6767906449165593/019f70d0-99bf-777f-8c3e-583f4e9ad942.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom, featuring a sleek vanity, pristine sink, modern toilet, and a relaxing bathtub with elegant tile surround.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d9f5d0f-bed7-4790-ac19-aef5103fc5d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-86cc-7488-880c-49754f2f40d3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a green armchair.",
        "public_id": "019f70d0-86cc-7488-880c-49754f2f40d3",
        "storage_key": "property/6767906449165593/019f70d0-86cc-7488-880c-49754f2f40d3.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, modern nightstands with stylish lamps, and a cozy green armchair. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a green armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89b5824b-7a67-433b-acd1-5dcb6a05de1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-87ae-7042-9a46-c68e6d610c3a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large white countertop.",
        "public_id": "019f70d0-87ae-7042-9a46-c68e6d610c3a",
        "storage_key": "property/6767906449165593/019f70d0-87ae-7042-9a46-c68e6d610c3a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a sleek white island countertop, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large white countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c033e07-dc08-49e4-8c3f-b1cf616e9a09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-857d-742f-864b-629c5202ddfd.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "019f70d0-857d-742f-864b-629c5202ddfd",
        "storage_key": "property/6767906449165593/019f70d0-857d-742f-864b-629c5202ddfd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a comfortable queen-size bed, elegant nightstand, and a dresser, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_852a753b-d47c-4788-b38c-0eca5fd34694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-86da-74d9-9aeb-d059dbdc845e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, a white quartz countertop, and light gray cabinets.",
        "public_id": "019f70d0-86da-74d9-9aeb-d059dbdc845e",
        "storage_key": "property/6767906449165593/019f70d0-86da-74d9-9aeb-d059dbdc845e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this beautifully appointed kitchen, featuring sleek stainless steel appliances and ample counter space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, a white quartz countertop, and light gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3559df8-5fe2-4e2e-b046-1be1a39aab5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-0948-7356-90e4-6b114e2fe3d0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
        "public_id": "019f70d0-0948-7356-90e4-6b114e2fe3d0",
        "storage_key": "property/6767906449165593/019f70d0-0948-7356-90e4-6b114e2fe3d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area. Perfect for enjoying sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c8ea970-737a-4391-bacd-88daeb5735ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-db0d-77bf-8b31-cef77799c8ca.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and a building with an overhang.",
        "public_id": "019f70cf-db0d-77bf-8b31-cef77799c8ca",
        "storage_key": "property/6767906449165593/019f70cf-db0d-77bf-8b31-cef77799c8ca.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, perfect for relaxing or socializing with friends and neighbors.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and a building with an overhang.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_879e67cc-ed6e-444f-97af-de482b1f0e3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-da44-7419-bba9-9231c9ec0652.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019f70cf-da44-7419-bba9-9231c9ec0652",
        "storage_key": "property/6767906449165593/019f70cf-da44-7419-bba9-9231c9ec0652.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85338b32-f93a-417e-9325-3afc47a730c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-d8a1-74c6-91bc-2f0718b25bec.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a fence.",
        "public_id": "019f70cf-d8a1-74c6-91bc-2f0718b25bec",
        "storage_key": "property/6767906449165593/019f70cf-d8a1-74c6-91bc-2f0718b25bec.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the community's sparkling outdoor pool, surrounded by comfortable lounge chairs for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fec0542d-989d-4f27-97dd-dc06a6404ba7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-cb66-730c-98d4-c1c9f30495ed.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills built into a brick counter.",
        "public_id": "019f70cf-cb66-730c-98d4-c1c9f30495ed",
        "storage_key": "property/6767906449165593/019f70cf-cb66-730c-98d4-c1c9f30495ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our community's built-in grilling station, featuring two professional-grade stainless steel grills.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills built into a brick counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10a97a4d-117c-4614-8d64-01362bb440ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-cb67-726f-9985-cbece4f46f2d.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with built-in grills and a concrete patio.",
        "public_id": "019f70cf-cb67-726f-9985-cbece4f46f2d",
        "storage_key": "property/6767906449165593/019f70cf-cb67-726f-9985-cbece4f46f2d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our modern built-in grills, perfect for entertaining guests on the spacious patio.",
      "link": "",
      "alt_text": "Outdoor kitchen with built-in grills and a concrete patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a71be6a-2482-499c-8d67-bbc0f9cdbb06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-c77e-7639-b6ca-61a367352699.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a surrounding fence.",
        "public_id": "019f70cf-c77e-7639-b6ca-61a367352699",
        "storage_key": "property/6767906449165593/019f70cf-c77e-7639-b6ca-61a367352699.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a surrounding fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23041658-2304-408b-acfb-4d2cb89d896e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-906b-7618-ae1c-d5db14d43f0f.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace, green sofa, and chairs, overlooking a pool.",
        "public_id": "019f70cf-906b-7618-ae1c-d5db14d43f0f",
        "storage_key": "property/6767906449165593/019f70cf-906b-7618-ae1c-d5db14d43f0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury living in this spacious apartment, featuring a modern fireplace, comfortable seating, and beautiful views of the pool area.",
      "link": "",
      "alt_text": "Modern living room with a fireplace, green sofa, and chairs, overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c91dc98-07fa-4df5-8829-2cb7a98c7175",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-8d46-73a1-beb4-582a4d7957ce.webp",
      "image_media": {
        "alt_text": "Open-concept living area with kitchen island, fireplace, and living room furniture.",
        "public_id": "019f70cf-8d46-73a1-beb4-582a4d7957ce",
        "storage_key": "property/6767906449165593/019f70cf-8d46-73a1-beb4-582a4d7957ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience spacious living in this open-concept apartment, featuring a modern kitchen, a cozy fireplace, and a comfortable living area perfect for relaxation and entertaining. Step outside to enjoy the community pool.",
      "link": "",
      "alt_text": "Open-concept living area with kitchen island, fireplace, and living room furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_960c1e42-ff35-4d7d-9074-e1ac660de748",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-9009-73f5-9fdb-537d4f5f417c.webp",
      "image_media": {
        "alt_text": "Chisholm Pointe monument sign",
        "public_id": "019f70cf-9009-73f5-9fdb-537d4f5f417c",
        "storage_key": "property/6767906449165593/019f70cf-9009-73f5-9fdb-537d4f5f417c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Chisholm Pointe, a beautiful apartment community with elegant signage.",
      "link": "",
      "alt_text": "Chisholm Pointe monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1bd995d-2ab4-415c-a0c3-de7c7771a9cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-87bc-750c-8b33-0dafbdf56a69.webp",
      "image_media": {
        "alt_text": "Outdoor pickleball court with a net and blue and green surface.",
        "public_id": "019f70cf-87bc-750c-8b33-0dafbdf56a69",
        "storage_key": "property/6767906449165593/019f70cf-87bc-750c-8b33-0dafbdf56a69.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle on our vibrant outdoor pickleball court. Perfect for friendly matches and staying fit.",
      "link": "",
      "alt_text": "Outdoor pickleball court with a net and blue and green surface.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b775fa7f-1fbf-4e75-b1a8-bd16d16b00ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-7507-74e0-bb5f-7bb7d5cff954.webp",
      "image_media": {
        "alt_text": "Outdoor sports court with pickleball lines and a net, adjacent to a pool and community building.",
        "public_id": "019f70cf-7507-74e0-bb5f-7bb7d5cff954",
        "storage_key": "property/6767906449165593/019f70cf-7507-74e0-bb5f-7bb7d5cff954.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our dedicated sports court, perfect for pickleball or tennis. Relax by the pool or socialize at the nearby community center.",
      "link": "",
      "alt_text": "Outdoor sports court with pickleball lines and a net, adjacent to a pool and community building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_defde2f0-8031-4a3d-938d-e10883405246",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-700d-7699-9b39-678720351ede.webp",
      "image_media": {
        "alt_text": "Outdoor pickleball court with residential buildings in the background.",
        "public_id": "019f70cf-700d-7699-9b39-678720351ede",
        "storage_key": "property/6767906449165593/019f70cf-700d-7699-9b39-678720351ede.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle on our outdoor pickleball court, a perfect amenity for residents looking to socialize and stay fit.",
      "link": "",
      "alt_text": "Outdoor pickleball court with residential buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3a2761b7-f8b4-46cc-b5f5-b3746de9cccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e071-740e-b051-3a28d554e3a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e071-740e-b051-3a28d554e3a5",
        "storage_key": "property/6767906449165593/019d2708-e071-740e-b051-3a28d554e3a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-dfb4a522328e",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a0855c7c-db29-4697-9609-4804a17ba5c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e105-7298-a1d0-07ff87167ff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e105-7298-a1d0-07ff87167ff2",
        "storage_key": "property/6767906449165593/019d2708-e105-7298-a1d0-07ff87167ff2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5570464",
      "poi_longitude": "-97.5088888",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-dfb4a522328e",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6417c241-3a08-4217-a5c4-c3783a6117e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "5600 N Pennsylvania Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual, upscale-casual chain for steak, pasta, pizza and burgers, plus gourmet cakes.",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and steak. They also highlight the friendly staff, generous portions, and extensive menu with options for everyone.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e074-75ef-a8f9-ef7188a2b74c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e074-75ef-a8f9-ef7188a2b74c",
        "storage_key": "property/6767906449165593/019d2708-e074-75ef-a8f9-ef7188a2b74c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/oklahoma-city-117.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=931265600312329473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "35.5260485",
      "poi_longitude": "-97.5471558",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-843-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-dfb4a522328e",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgc4NZkAasocRAUUoIiGF7Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1e04da66-3473-4ade-bd5e-f0f53440ee34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Cafe Kacao",
      "poi_type": "Restaurants",
      "poi_address": "3325 N Classen Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Breakfast-to-dinner menu of Guatemalan eats including breakfast burritos, in a trendy setting.",
      "poi_long_description": "People say this Guatemalan restaurant serves delicious and authentic dishes, including carne asada, chilaquiles, and French toast. They highlight the generous portions, flavorful food, and the beautiful presentation of the dishes. They also like the friendly staff and the vibrant, colorful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e0ce-763e-b073-89e61e68895e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e0ce-763e-b073-89e61e68895e",
        "storage_key": "property/6767906449165593/019d2708-e0ce-763e-b073-89e61e68895e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cafekacao.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4497070532078455595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cafe-kacao",
      "poi_latitude": "35.5038943",
      "poi_longitude": "-97.5347616",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-357-9913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-dfb4a522328e",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1xxbagQsocRK8tpitLNaD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d0f1f7da-18e6-432c-b7b6-e626cc457b20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e641-703a-9528-65109673240f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e641-703a-9528-65109673240f",
        "storage_key": "property/6767906449165593/019d2708-e641-703a-9528-65109673240f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-dfb4a522328e",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-dfb4a522328e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1a43a629-ff38-4873-828c-ace5895bfa1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Penn Square Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 Northwest Expy, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Fashion-focused destination with over 140 specialty shops, a movie theater and an arcade.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a large food court with diverse options. They also highlight the clean facilities, helpful security, and convenient parking.\n\nSome reviews mention the escalators can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e5aa-74cd-ac51-3afc132395e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e5aa-74cd-ac51-3afc132395e8",
        "storage_key": "property/6767906449165593/019d2708-e5aa-74cd-ac51-3afc132395e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/penn-square-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811350003534984838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penn-square-mall",
      "poi_latitude": "35.5249271",
      "poi_longitude": "-97.5441961",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-842-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-16f6-716c-afe4-94e9f7ff05f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-16f6-716c-afe4-94e9f7ff05f1",
        "storage_key": "property/6767906449165593/019d2709-16f6-716c-afe4-94e9f7ff05f1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqd3wbBUasocRhvb-2-7rAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9e61c230-b2be-45f4-9c6d-f162d17cc1a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e68d-70d9-9ddb-96e351be1026.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e68d-70d9-9ddb-96e351be1026",
        "storage_key": "property/6767906449165593/019d2708-e68d-70d9-9ddb-96e351be1026.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-16f6-716c-afe4-94e9f7ff05f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-16f6-716c-afe4-94e9f7ff05f1",
        "storage_key": "property/6767906449165593/019d2709-16f6-716c-afe4-94e9f7ff05f1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_22399bce-1755-4ac3-a22f-03284e2b2dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Groceries, produce, artisan cheese and baked goods at a modern supermarket.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, cheeses, and baked goods, including many organic and vegan options. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-e64f-70c7-b45e-58e39e833d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e64f-70c7-b45e-58e39e833d18",
        "storage_key": "property/6767906449165593/019d2708-e64f-70c7-b45e-58e39e833d18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-e3f22f32d399",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7dfd7246-213c-4c27-ace2-702e797d96df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain featuring organic, gluten-free and vegan options, plus wine and flowers.",
      "poi_long_description": "People say this grocery store offers a wide selection of unique items, fresh produce, organic food, snacks, and wine. They highlight the affordable prices, good quality, and convenient pre-prepared meals. They also like the friendly staff and the pleasant, welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-eaad-7611-80d3-cbcdf3ad5c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eaad-7611-80d3-cbcdf3ad5c30",
        "storage_key": "property/6767906449165593/019d2708-eaad-7611-80d3-cbcdf3ad5c30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-e3f22f32d399",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d65947ce-4d04-40ea-ba1f-83dff6336585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fresh meat and produce alongside bulk bins, plus a deli counter.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of bulk items, including coffee beans, spices, and baking supplies, as well as fresh produce, delicious sushi, and a great deli selection. They also highlight the low prices, friendly staff, and clean store.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-ec89-7747-bffb-038fde9c08ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec89-7747-bffb-038fde9c08ad",
        "storage_key": "property/6767906449165593/019d2708-ec89-7747-bffb-038fde9c08ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1757-74fd-a02e-e3f22f32d399",
        "storage_key": "property/6767906449165593/019d2709-1757-74fd-a02e-e3f22f32d399.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_62826a75-05c0-4859-a559-4ea05eb2ad92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-ec7f-709b-be9b-f5299c9e1e47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec7f-709b-be9b-f5299c9e1e47",
        "storage_key": "property/6767906449165593/019d2708-ec7f-709b-be9b-f5299c9e1e47.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1774-76eb-9d23-4eac05efae7c",
        "storage_key": "property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_06909555-656b-449d-a43b-243507ef9216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Belle Isle Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5501 N Villa Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Warm, friendly public library with a children’s area, study rooms and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-ec0c-7477-b900-52a67de5039a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec0c-7477-b900-52a67de5039a",
        "storage_key": "property/6767906449165593/019d2708-ec0c-7477-b900-52a67de5039a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12135984821329026772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belle-isle-library---metropolitan-library-system",
      "poi_latitude": "35.52557300000001",
      "poi_longitude": "-97.5569692",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1774-76eb-9d23-4eac05efae7c",
        "storage_key": "property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWXwrG2gasocR1F7ZUuWta6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_558c8820-1d41-43f4-bf9d-260d126bb2b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f092-72c6-8f0a-18b914315ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f092-72c6-8f0a-18b914315ca3",
        "storage_key": "property/6767906449165593/019d2708-f092-72c6-8f0a-18b914315ca3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1774-76eb-9d23-4eac05efae7c",
        "storage_key": "property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d2439d83-da46-48a0-8aad-270f41762717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo and botanical garden with giraffe and lion enclosures, a petting zoo and a dinosaur trail.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, giraffes, and flamingos, and provides opportunities for interactive experiences like feeding giraffes and petting stingrays. They highlight the affordable ticket prices, especially with discounts, and the clean, well-maintained grounds with beautiful landscaping. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f1b1-7791-b120-bd6638e936e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f1b1-7791-b120-bd6638e936e4",
        "storage_key": "property/6767906449165593/019d2708-f1b1-7791-b120-bd6638e936e4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_6bfcbac0-3cce-492f-9dde-f1ff8f31c733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of interactive exhibits, hands-on activities, and a planetarium, providing educational and fun experiences for all ages. They highlight the membership is worth it for families and the museum is a great place to take out-of-town guests. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f291-733b-9b2d-ae4acc8b6be9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f291-733b-9b2d-ae4acc8b6be9",
        "storage_key": "property/6767906449165593/019d2708-f291-733b-9b2d-ae4acc8b6be9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b59-76fd-8a85-4c04e24ffba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b59-76fd-8a85-4c04e24ffba4",
        "storage_key": "property/6767906449165593/019d2709-1b59-76fd-8a85-4c04e24ffba4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9b9004d2-6125-4ef5-b4d7-49056e308bf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Western heritage and cowboy history come to life at this museum with gardens, restaurants and a gift shop.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, historical artifacts, and engaging exhibits, including a recreation of an old West town and a rodeo exhibit. They highlight the educational and immersive experience, and the beautiful outdoor sculptures and gardens. They also like the friendly and knowledgeable staff, and the well-maintained and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f2ca-71bc-844f-37eba7b01f8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f2ca-71bc-844f-37eba7b01f8a",
        "storage_key": "property/6767906449165593/019d2708-f2ca-71bc-844f-37eba7b01f8a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-cowboy--western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b59-76fd-8a85-4c04e24ffba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b59-76fd-8a85-4c04e24ffba4",
        "storage_key": "property/6767906449165593/019d2709-1b59-76fd-8a85-4c04e24ffba4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_30c2f845-59c7-4426-8884-daa48bcf99fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Theme park with dozens of rides, including roller coasters, plus live entertainment.",
      "poi_long_description": "People say this theme park offers a variety of rides, including roller coasters, water rides, and a water park, as well as live shows and a Fright Fest event. They also highlight the season pass is a great value, the staff is friendly, and the park is clean with plenty of shade.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f589-7579-812c-cea15d8a7409.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f589-7579-812c-cea15d8a7409",
        "storage_key": "property/6767906449165593/019d2708-f589-7579-812c-cea15d8a7409.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_906f0331-c98b-4e9f-93a5-fd4b7b51921a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f695-7638-a901-baac922f304a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f695-7638-a901-baac922f304a",
        "storage_key": "property/6767906449165593/019d2708-f695-7638-a901-baac922f304a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_9dc6318d-8968-4e35-b890-b719ac88e61f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f72e-74fe-989a-2222d6d79e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f72e-74fe-989a-2222d6d79e31",
        "storage_key": "property/6767906449165593/019d2708-f72e-74fe-989a-2222d6d79e31.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f008c10b-ea85-4658-8e23-e16b388f74c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-f7cb-7228-86f5-f040aab64049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f7cb-7228-86f5-f040aab64049",
        "storage_key": "property/6767906449165593/019d2708-f7cb-7228-86f5-f040aab64049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_77430a47-cc24-443c-a5ae-8310b5d83d07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers fun classes and birthday parties for young children. They highlight the positive and encouraging atmosphere, and the confidence children gain. They also like the kind, welcoming, and dedicated staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-fb27-7112-aedc-e0b372084593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fb27-7112-aedc-e0b372084593",
        "storage_key": "property/6767906449165593/019d2708-fb27-7112-aedc-e0b372084593.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1774-76eb-9d23-4eac05efae7c",
        "storage_key": "property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_778aa9f5-508b-486f-8fa9-b9fd39c1fb4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain gym offering free high-school memberships, plus tanning beds, massage chairs, and TVs.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and workout options, including tanning beds and massage chairs. They also highlight the clean facilities, spacious layout, and convenient location.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-fb11-719e-adb4-e550d370fcb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fb11-719e-adb4-e550d370fcb4",
        "storage_key": "property/6767906449165593/019d2708-fb11-719e-adb4-e550d370fcb4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-nw-expressway-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17337479712866526724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5386202",
      "poi_longitude": "-97.5960525",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-242-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWPVatwasocRBGbz4fAZm_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e0414f96-344a-4517-a284-277ac5d1ec7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and powerlifting stations, and has a spacious layout with an outdoor workout area.\n\nOther reviews mention the restrooms can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-fc43-74fe-bfc7-d019f3a67116.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fc43-74fe-bfc7-d019f3a67116",
        "storage_key": "property/6767906449165593/019d2708-fc43-74fe-bfc7-d019f3a67116.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_25c1c3f6-9bc5-4bfb-a0e7-93557ce0cb2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-fd31-753f-9cdd-63a44ad36a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fd31-753f-9cdd-63a44ad36a73",
        "storage_key": "property/6767906449165593/019d2708-fd31-753f-9cdd-63a44ad36a73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d4e314d3-8bec-4c7f-8d57-a04208b90bd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-ffee-76c9-96a4-d9dd5d106c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ffee-76c9-96a4-d9dd5d106c41",
        "storage_key": "property/6767906449165593/019d2708-ffee-76c9-96a4-d9dd5d106c41.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0d894efc-33a1-414a-b6c9-c35deae0f3e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1700 Belle Isle Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Retail store for cosmetics, makeup, fragrance, hair care and skin care.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2708-ff9c-737a-a733-49da84019d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ff9c-737a-a733-49da84019d1f",
        "storage_key": "property/6767906449165593/019d2708-ff9c-737a-a733-49da84019d1f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-1185",
      "poi_directions_map_url": "https://maps.google.com/?cid=17168229984475748421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.5249292",
      "poi_longitude": "-97.5360441",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-840-7807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1GrhRcasocRRRjjrjXOQe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_b84a391d-c19f-4333-a751-d1f8169d5c05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-0086-722b-9ab7-c8720962e54f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0086-722b-9ab7-c8720962e54f",
        "storage_key": "property/6767906449165593/019d2709-0086-722b-9ab7-c8720962e54f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1774-76eb-9d23-4eac05efae7c",
        "storage_key": "property/6767906449165593/019d2709-1774-76eb-9d23-4eac05efae7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff81a8f5-3115-4169-80d5-09f0b5fc6dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-02a5-7275-aa3f-12fa5ad21bad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-02a5-7275-aa3f-12fa5ad21bad",
        "storage_key": "property/6767906449165593/019d2709-02a5-7275-aa3f-12fa5ad21bad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b8a-7798-a194-5c07ad290d00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b8a-7798-a194-5c07ad290d00",
        "storage_key": "property/6767906449165593/019d2709-1b8a-7798-a194-5c07ad290d00.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ed4f7d71-f728-4a84-84fe-b4e59265c5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-04b1-7274-92a1-2e889d74a463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-04b1-7274-92a1-2e889d74a463",
        "storage_key": "property/6767906449165593/019d2709-04b1-7274-92a1-2e889d74a463.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b8a-7798-a194-5c07ad290d00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b8a-7798-a194-5c07ad290d00",
        "storage_key": "property/6767906449165593/019d2709-1b8a-7798-a194-5c07ad290d00.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_746f60be-ed0c-4b71-9ea0-52a91d7e33eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-05f9-745c-b3d2-19bc3fd2f417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-05f9-745c-b3d2-19bc3fd2f417",
        "storage_key": "property/6767906449165593/019d2709-05f9-745c-b3d2-19bc3fd2f417.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b5f-7589-95e4-2c32da776add",
        "storage_key": "property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eeb4008c-fbb1-4f5e-8392-a1890b698590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Will Rogers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW 36th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Colorful arboretum featuring disc golf, tennis courts, a greenhouse and picnic sites.",
      "poi_long_description": "People say this botanical garden offers beautiful and well-maintained flower beds with a great variety of plants and flowers. They highlight the free entry and the well-labeled trees, plants, and flowers. They also like the beautiful setting for weddings and quinceañeras.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-064a-7104-b567-d84ee97acc89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-064a-7104-b567-d84ee97acc89",
        "storage_key": "property/6767906449165593/019d2709-064a-7104-b567-d84ee97acc89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/will-rogers-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7664107588336218919&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-gardens",
      "poi_latitude": "35.5069148",
      "poi_longitude": "-97.5770745",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-297-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b5f-7589-95e4-2c32da776add",
        "storage_key": "property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YeiZYMasocRJ_Mn0z5hXGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_196cfc00-f046-47cb-b126-d02fd187acce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-08b9-71ce-8e66-5d61488d42fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-08b9-71ce-8e66-5d61488d42fa",
        "storage_key": "property/6767906449165593/019d2709-08b9-71ce-8e66-5d61488d42fa.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b5f-7589-95e4-2c32da776add",
        "storage_key": "property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bad135aa-480d-4756-8439-9a7d72ed1b39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-0a85-74fa-a6a6-e86900089238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0a85-74fa-a6a6-e86900089238",
        "storage_key": "property/6767906449165593/019d2709-0a85-74fa-a6a6-e86900089238.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1b5f-7589-95e4-2c32da776add",
        "storage_key": "property/6767906449165593/019d2709-1b5f-7589-95e4-2c32da776add.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a5ac8c7c-dc9e-4430-87ee-64f8185249a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-0b2b-7081-aec3-5068ea32d2aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0b2b-7081-aec3-5068ea32d2aa",
        "storage_key": "property/6767906449165593/019d2709-0b2b-7081-aec3-5068ea32d2aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1ecd-74bf-86c2-dfc6c9d8c174.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ecd-74bf-86c2-dfc6c9d8c174",
        "storage_key": "property/6767906449165593/019d2709-1ecd-74bf-86c2-dfc6c9d8c174.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_c8d6d981-2476-4bf6-b96f-5ce14bce5d0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-0c25-7461-9b3e-741f5ca537a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0c25-7461-9b3e-741f5ca537a7",
        "storage_key": "property/6767906449165593/019d2709-0c25-7461-9b3e-741f5ca537a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7db7acf1-0902-49a8-8d21-8cefd6eb95a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-0e49-753d-ab41-f857a8c25119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0e49-753d-ab41-f857a8c25119",
        "storage_key": "property/6767906449165593/019d2709-0e49-753d-ab41-f857a8c25119.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_308bcf6f-dc5d-41a4-8c1a-c86565644337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-105d-760c-baaa-e3c0bfce7a09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-105d-760c-baaa-e3c0bfce7a09",
        "storage_key": "property/6767906449165593/019d2709-105d-760c-baaa-e3c0bfce7a09.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_91217477-2167-4043-908a-3d56b0e5d21e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1223-7029-a832-051b985224f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1223-7029-a832-051b985224f3",
        "storage_key": "property/6767906449165593/019d2709-1223-7029-a832-051b985224f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4ff4742b-2b4f-4b6c-bf0d-c6b894ea6183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-114f-70b7-88e5-00fd89238110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-114f-70b7-88e5-00fd89238110",
        "storage_key": "property/6767906449165593/019d2709-114f-70b7-88e5-00fd89238110.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1adc-76f8-b7f4-c78f8415750f",
        "storage_key": "property/6767906449165593/019d2709-1adc-76f8-b7f4-c78f8415750f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_17d04728-d58d-4d02-9b2c-9c9e3dea1fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Quail Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "11700 Thorn Ridge Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.okcps.org/Domain/34",
      "poi_directions_map_url": "https://maps.google.com/?cid=5934334125062149098&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-elementary-school",
      "poi_latitude": "35.5885984",
      "poi_longitude": "-97.5713615",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-587-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ72UkXX4bsocR6tPO_nH9WlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dd2babad-71d5-4d00-b089-72e39b4245d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Stonegate Elementary School",
      "poi_type": "Education",
      "poi_address": "2525 NW 112th St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12482700057558395251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stonegate-elementary-school",
      "poi_latitude": "35.5841914",
      "poi_longitude": "-97.5603553",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-751-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-70QIQbsocRcymE8JB1O60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a0ab691a-718e-41c8-8e09-f66de87b82f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Ridgeview Elementary School",
      "poi_type": "Education",
      "poi_address": "10010 Ridgeview Dr, The Village, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-d86e-71ac-9333-e599f71ddd36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d86e-71ac-9333-e599f71ddd36",
        "storage_key": "property/6767906449165593/019d7911-d86e-71ac-9333-e599f71ddd36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Ridgeview",
      "poi_directions_map_url": "https://maps.google.com/?cid=9883859228491310922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeview-elementary-school",
      "poi_latitude": "35.572391",
      "poi_longitude": "-97.5589732",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-587-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlVFATZgbsocRSucw9JmFKok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_530267e0-025d-4f4f-a0fd-3f2215f385d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "John Marshall Middle School",
      "poi_type": "Education",
      "poi_address": "2401 NW 115th Terrace, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-d59e-7129-b4c3-e628147317ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d59e-7129-b4c3-e628147317ad",
        "storage_key": "property/6767906449165593/019d7911-d59e-7129-b4c3-e628147317ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Domain/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=12695469249844632585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-middle-school",
      "poi_latitude": "35.5881777",
      "poi_longitude": "-97.5562916",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-587-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm0t9k4gbsocRCVzi7QReL7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_96b13e88-f8b2-4280-bae8-e74f3f1f6c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-d305-70bb-8631-5c36634ee821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d305-70bb-8631-5c36634ee821",
        "storage_key": "property/6767906449165593/019d7911-d305-70bb-8631-5c36634ee821.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_981db263-2cc8-441c-9db6-abcbb142057b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "The Catholic School of St. Eugene",
      "poi_type": "Education",
      "poi_address": "2400 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-d304-701a-92e3-9b0120fb43e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d304-701a-92e3-9b0120fb43e5",
        "storage_key": "property/6767906449165593/019d7911-d304-701a-92e3-9b0120fb43e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.steugeneschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10217977840465228397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-catholic-school-of-st-eugene",
      "poi_latitude": "35.5794394",
      "poi_longitude": "-97.5580453",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-751-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw98bCpAbsocRbTK-b7WMzY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f3f4f54a-867c-4eb1-9959-f6474302f603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "John Marshall High School",
      "poi_type": "Education",
      "poi_address": "12201 Portland Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-dd42-766f-b590-37cfca1cdfdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-dd42-766f-b590-37cfca1cdfdb",
        "storage_key": "property/6767906449165593/019d7911-dd42-766f-b590-37cfca1cdfdb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Johnmarshall",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761330892857833865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-high-school",
      "poi_latitude": "35.5932637",
      "poi_longitude": "-97.5882344",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-587-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnV-lOJ8csocRiXlmUYkR-r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9a08d0ca-197c-4d6d-9c93-b3c240319d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-de22-737c-86fb-7deb24672996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-de22-737c-86fb-7deb24672996",
        "storage_key": "property/6767906449165593/019d7911-de22-737c-86fb-7deb24672996.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e809c131-8fbc-44e4-bfb5-ab55074ff5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-e8aa-726d-b31d-debd0e2735ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e8aa-726d-b31d-debd0e2735ba",
        "storage_key": "property/6767906449165593/019d7911-e8aa-726d-b31d-debd0e2735ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b2b4eda4-ecb5-4438-a30c-66793dc44ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-eb7e-7691-828f-abca431f9bbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-eb7e-7691-828f-abca431f9bbb",
        "storage_key": "property/6767906449165593/019d7911-eb7e-7691-828f-abca431f9bbb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffb-730c-9e17-4c3c8f92a3d5",
        "storage_key": "property/6767906449165593/019cfb3b-dffb-730c-9e17-4c3c8f92a3d5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8a53fdfe-31ae-4345-995f-8d7f5aaa916e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Mahogany Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3241 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sophisticated restaurant offering steaks, seafood & creative cocktails in refined surroundings.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, seafood, and sides, including lobster macaroni and cheese and carrot cake. They highlight the generous portions, the attentive and professional staff, and the beautiful ambiance. They also like the accommodating table placement and the thoughtful service that makes guests feel special.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-ece5-72b5-9312-540ffb153d34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ece5-72b5-9312-540ffb153d34",
        "storage_key": "property/6767906449165593/019d7911-ece5-72b5-9312-540ffb153d34.webp",
        "width": 1024,
        "height": 584
      },
      "poi_business_url": "http://mahoganyprimesteakhouse.com/locations/mahogany-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052219944289353941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-prime-steakhouse",
      "poi_latitude": "35.6103673",
      "poi_longitude": "-97.5755325",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-748-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdl3kYwcsocR1cDmKfnN_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bdffa690-4b23-47ff-a2c3-74ffabe3de5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Hopscotch Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "10909 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Homey joint with pool tables & chess games, serving steak, burgers & seafood, plus cocktails & beer.",
      "poi_long_description": "People say this restaurant serves delicious chicken pot pie, meatloaf, and fish and chips. They also highlight the fun vibe with games and pool tables, and the attentive service.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-f529-758b-9cdf-72692155f1d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f529-758b-9cdf-72692155f1d0",
        "storage_key": "property/6767906449165593/019d7911-f529-758b-9cdf-72692155f1d0.webp",
        "width": 554,
        "height": 558
      },
      "poi_business_url": "http://www.hopscotchokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18057195703532085437&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hopscotch-kitchen-bar",
      "poi_latitude": "35.5811938",
      "poi_longitude": "-97.56757770000002",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-4246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5-YmYIbsocRvWC9PNILmPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8efd5195-1e5e-4d8b-af93-29320044c693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Tana Thai Bistro",
      "poi_type": "Restaurants",
      "poi_address": "10700 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Cozy fixture in a strip mall serving traditional Thai dishes in an unpretentious setting.",
      "poi_long_description": "People say this Thai restaurant serves delicious Panang Curry, Pad See Ew, and Thai coffee. They also highlight the attentive and kind service, and the cozy atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-f90f-772a-80d1-9acb98eb5675.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f90f-772a-80d1-9acb98eb5675",
        "storage_key": "property/6767906449165593/019d7911-f90f-772a-80d1-9acb98eb5675.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700536105955686745&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tana-thai-bistro",
      "poi_latitude": "35.5778461",
      "poi_longitude": "-97.566805",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-242-2075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZbGap0bsocRWfmuQmeC49k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_479d8288-5e8c-4c8e-95ed-e83eeb4931cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Hacienda Tacos",
      "poi_type": "Restaurants",
      "poi_address": "Shoppes at NorthPark, 12086 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Vibrant, low-key eatery serving Mexican fare such as tacos & quesadillas plus margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, quesadillas, and nachos. They also highlight the fresh, house-made tortillas, chips, and salsa, and the flavorful, seasoned meats.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-f7c0-7570-a22e-103bbfdef4a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f7c0-7570-a22e-103bbfdef4a1",
        "storage_key": "property/6767906449165593/019d7911-f7c0-7570-a22e-103bbfdef4a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://haciendatacos.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037182435171725060&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hacienda-tacos",
      "poi_latitude": "35.592613",
      "poi_longitude": "-97.5662696",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-254-3140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcCRxX8csocRBG-LxnSEj94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0fba045a-76b2-42b8-a474-054465e62c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Casa Perico Mexican Grille",
      "poi_type": "Restaurants",
      "poi_address": "11109 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual, family-owned option serving standard Mexican fare, cocktails and beer in a colorful space with a patio.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious fajitas, carnitas, and habanero salsa. They also highlight the friendly and attentive staff, and the great portions and prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7911-fba0-774c-bece-909541f65dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fba0-774c-bece-909541f65dc3",
        "storage_key": "property/6767906449165593/019d7911-fba0-774c-bece-909541f65dc3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://casaperico.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4166221275886795784&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casa-perico-mexican-grille",
      "poi_latitude": "35.5825875",
      "poi_longitude": "-97.5676184",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-2853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_c9uuWEbsocRCDzoRC1k0Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_283cdd67-b3d7-4d91-9531-14ac08bb0884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Hefner Grill",
      "poi_type": "Restaurants",
      "poi_address": "9201 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Sophisticated pub grub, steaks & seafood in a waterfront setting with live music & Sunday brunch.",
      "poi_long_description": "People say this seafood restaurant offers delicious lobster rolls, fish tacos, and calamari. They highlight the beautiful lake view, especially at sunset, and the friendly staff. They also like the patio and the live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-02bf-7198-a5e3-9d866cb32506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-02bf-7198-a5e3-9d866cb32506",
        "storage_key": "property/6767906449165593/019d7912-02bf-7198-a5e3-9d866cb32506.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hefnergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4950347523357226635&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-grill",
      "poi_latitude": "35.5627444",
      "poi_longitude": "-97.5784278",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-748-6113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-h_NAkbsocRizZxLNgqs0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_0df90001-a6f9-41bd-9df0-6b69b2e61538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "2900 W Britton Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Laid-back bar featuring burgers, bison burgers and onion burgers made from scratch, plus beers and fries.",
      "poi_long_description": "People say this hamburger restaurant serves juicy, flavorful burgers with a variety of options, including bison, turkey, and veggie patties, and delicious sides like chili cheese fries and potato bundles. They highlight the fun, lively atmosphere, perfect for watching games, and the reasonable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-01f9-71d8-b1b8-da210ea589b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-01f9-71d8-b1b8-da210ea589b0",
        "storage_key": "property/6767906449165593/019d7912-01f9-71d8-b1b8-da210ea589b0.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-britton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1801864854338795382&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-burgers-beer",
      "poi_latitude": "35.5653246",
      "poi_longitude": "-97.5677631",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-254-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJka4lnaAbsocRdvcf0ImCARk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_2df242e1-7945-4466-ac9e-a5985905d0dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Uncle Julio's Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1344 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this restaurant serves delicious Mexican food, including bacon-wrapped shrimp, fajitas, and enchiladas. They also highlight the fun atmosphere, the delicious chocolate piñata, and the attentive service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-0329-70df-8304-2144f9b29f79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0329-70df-8304-2144f9b29f79",
        "storage_key": "property/6767906449165593/019d7912-0329-70df-8304-2144f9b29f79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6592367220314025478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-oklahoma-city",
      "poi_latitude": "35.6075896",
      "poi_longitude": "-97.5374138",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-486-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4TdSPodsocRBi6_Gw_LfFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ddd870e2-9e1c-4010-9232-364a2a7ead2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2425 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious pizookies, ribeye steak, and mashed potatoes. They also highlight the friendly and attentive staff, and the great dining experience.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-05b4-753b-a83b-32ce66cd7a7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-05b4-753b-a83b-32ce66cd7a7c",
        "storage_key": "property/6767906449165593/019d7912-05b4-753b-a83b-32ce66cd7a7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/ok/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813775833426105589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bj-s-restaurant-brewhouse",
      "poi_latitude": "35.6103047",
      "poi_longitude": "-97.5578727",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-748-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5L30WccsocR9RRpjAmIVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_84cc9207-cc20-4027-82eb-4eb437bbafda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Black Bear Diner Quail Springs",
      "poi_type": "Restaurants",
      "poi_address": "3015 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, pancakes, and homemade sausage patties. They also highlight the generous portions, reasonable prices, and fun, cozy atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-0939-720f-91c5-9bb5898be950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0939-720f-91c5-9bb5898be950",
        "storage_key": "property/6767906449165593/019d7912-0939-720f-91c5-9bb5898be950.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/quail-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10302023260027666703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-quail-springs",
      "poi_latitude": "35.6103497",
      "poi_longitude": "-97.5708111",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-749-5992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78HkHYscsocRD8HCkZIj-I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3c56ee09-f8b9-4125-b59d-6827dfc65ab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Kyuramen x TBaar - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "2740 NW 140th St suite F, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Japanese-style eatery serving up ramen and small plates in a casual atmosphere.",
      "poi_long_description": "People say this ramen restaurant serves flavorful ramen, gyoza, and omurice, and offers a variety of boba teas and smoothies. They highlight the unique honeycomb seating, the wish tree, and the overall refreshing atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-100b-74a7-beb3-2e11d8d9ad7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-100b-74a7-beb3-2e11d8d9ad7f",
        "storage_key": "property/6767906449165593/019d7912-100b-74a7-beb3-2e11d8d9ad7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kyuramen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13734846288959488399&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kyuramen-x-tbaar-oklahoma-city",
      "poi_latitude": "35.6130422",
      "poi_longitude": "-97.5648326",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-730-6686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yr1kogdsocRj8EF8u35m74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_05897dbe-9061-47dd-87d5-5205586da5c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Naan Cuisine of India",
      "poi_type": "Restaurants",
      "poi_address": "12215 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Indian restaurant serves delicious butter chicken, garlic naan, and chicken tikka masala. They also highlight the generous portions, fresh ingredients, and flavorful, authentic dishes.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-1338-70ac-b210-bbb96c1caf76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1338-70ac-b210-bbb96c1caf76",
        "storage_key": "property/6767906449165593/019d7912-1338-70ac-b210-bbb96c1caf76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.naancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5922812203573884507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "naan-cuisine-of-india",
      "poi_latitude": "35.5941025",
      "poi_longitude": "-97.5509483",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-752-5283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUDnG3cdsocRW7ZemVEOMlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_f67320a2-275d-4491-8e5a-b8dc41e8a126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Hatch Early Mood Food",
      "poi_type": "Restaurants",
      "poi_address": "13230 Pawnee Dr Suite 112, Oklahoma City, OK 73114, USA",
      "poi_short_description": "High-ceilinged space with an industrial-chic vibe serving all-day breakfast fare plus lunch bites.",
      "poi_long_description": "People say this brunch restaurant serves tasty food, including decadent specialty pancakes and delicious waffles. They also highlight the friendly staff, quick service, and upbeat, appealing atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-111b-76bc-ab85-eace809e943f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-111b-76bc-ab85-eace809e943f",
        "storage_key": "property/6767906449165593/019d7912-111b-76bc-ab85-eace809e943f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hatchearlymoodfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8334602234314933719&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hatch-early-mood-food",
      "poi_latitude": "35.604193",
      "poi_longitude": "-97.5340069",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-2974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dffa-774c-a9cb-f7c5b8dbc718",
        "storage_key": "property/6767906449165593/019cfb3b-dffa-774c-a9cb-f7c5b8dbc718.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJod1fxhocsocR18WE0JJ0qnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_d622e18a-9f22-46eb-8940-135df6c63e0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "13601 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop has a convenient drive-thru and offers popular drinks like chai tea and pink drinks. They also highlight the friendly staff and efficient service.\n\nSome reviews mention the drinks can be made incorrectly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-11e7-72df-9e4d-235028bd02b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-11e7-72df-9e4d-235028bd02b3",
        "storage_key": "property/6767906449165593/019d7912-11e7-72df-9e4d-235028bd02b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.ca/store-locator/store/1030994/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2217484800767464764&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.60814",
      "poi_longitude": "-97.56787",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-754-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-752a-778b-b7ba-66f917db76a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-752a-778b-b7ba-66f917db76a2",
        "storage_key": "property/6767906449165593/019d7912-752a-778b-b7ba-66f917db76a2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-RQ2vXEdsocRPJWSdK0Wxh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_89a80e44-d2c7-4912-b2af-41879a8ac8d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Teapioca Lounge",
      "poi_type": "Restaurants",
      "poi_address": "13415 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Modern hangout with a wide range of cream teas, coffee & smoothies, plus desserts & board games.",
      "poi_long_description": "Modern hangout with a wide range of cream teas, coffee & smoothies, plus desserts & board games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-1b53-7284-835a-9bf5d5559b1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1b53-7284-835a-9bf5d5559b1f",
        "storage_key": "property/6767906449165593/019d7912-1b53-7284-835a-9bf5d5559b1f.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.teapiocalounge.com/teapioca-quail-springs-oklahoma-city-boba-tea",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377513644293000482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teapioca-lounge",
      "poi_latitude": "35.6064157",
      "poi_longitude": "-97.5498631",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-849-6981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7SVQmwcsocRIo36jkoLCv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_a0492db7-7b29-4f1f-8da7-db198de9425b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Shoppes at Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 N May Ave, Oklahoma City, OK 73156, USA",
      "poi_short_description": "Shopping complex showcasing shops, from kidswear to jewelry, plus eateries and a movie theater.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-1c8e-71ca-9154-f12528046c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1c8e-71ca-9154-f12528046c79",
        "storage_key": "property/6767906449165593/019d7912-1c8e-71ca-9154-f12528046c79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northparkokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10911568943014137873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoppes-at-northpark",
      "poi_latitude": "35.591473",
      "poi_longitude": "-97.566083",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0-WkH8csocREdCKRiSubZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5b8821ad-ddff-4ff6-9a6f-bfbe0c85c71f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "The Market at Quail Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "12202 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-1cb2-738d-8892-88774046670a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1cb2-738d-8892-88774046670a",
        "storage_key": "property/6767906449165593/019d7912-1cb2-738d-8892-88774046670a.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054793782763140957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-market-at-quail-springs",
      "poi_latitude": "35.5936682",
      "poi_longitude": "-97.5662446",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-752-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_2q1qmAcsocRXTdz-ik8JkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f488eff4-e806-45d3-9516-b2d07c6e03cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Casady Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9327 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2082-7389-9619-507d60b65070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2082-7389-9619-507d60b65070",
        "storage_key": "property/6767906449165593/019d7912-2082-7389-9619-507d60b65070.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://casadysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1395385190476482281&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-square",
      "poi_latitude": "35.5652787",
      "poi_longitude": "-97.5512342",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-752-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFckuw74bsocR6QYxC3BnXRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c10760a1-5641-4fb0-861f-772c4cada9db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide variety of goods, including fresh produce and bakery items. They also highlight the convenient layout, spacious aisles, and clean environment, as well as the helpful staff and easy parking.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2290-7540-8ab1-a37e0ba89fd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2290-7540-8ab1-a37e0ba89fd8",
        "storage_key": "property/6767906449165593/019d7912-2290-7540-8ab1-a37e0ba89fd8.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.samsclub.com/club/8117-oklahoma-city-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=9968560549527357001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "35.6071604",
      "poi_longitude": "-97.5462298",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-748-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ30O3VGscsocRSQaNDAFxV4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e308ab89-f411-4e47-93d3-47d1cea0d59b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "13924 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of home decor and holiday items. They also highlight the polite and helpful staff.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2415-736a-877c-2bac9a02ba6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2415-736a-877c-2bac9a02ba6d",
        "storage_key": "property/6767906449165593/019d7912-2415-736a-877c-2bac9a02ba6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/quail-springs/1397",
      "poi_directions_map_url": "https://maps.google.com/?cid=3776845119011340636&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.6124909",
      "poi_longitude": "-97.5467606",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-752-0183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe5CavWocsocRXMFWCqAMajQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_dbac3bba-36e3-4ac0-a2b3-d7a774c6e7dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of plants, flowers, yard decor, and building supplies. They also highlight the helpful and knowledgeable staff, and the organized aisles.\n\nOther reviews mention the return policy can be restrictive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2669-77ff-b582-2890dc709162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2669-77ff-b582-2890dc709162",
        "storage_key": "property/6767906449165593/019d7912-2669-77ff-b582-2890dc709162.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "35.606458",
      "poi_longitude": "-97.556346",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2621a34a-81cf-451a-9729-09e7760cb604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Living Spaces",
      "poi_type": "Shopping & Retail",
      "poi_address": "13502 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Retailer offering home furnishings, including sofas and mattresses, along with lighting and rugs.",
      "poi_long_description": "People say this furniture store offers a wide selection of furniture, including indoor and outdoor options, and a variety of styles and price points. They highlight the no-pressure shopping experience, the knowledgeable and helpful staff, and the quick and easy purchase process. They also like the clean and spacious store, and the kid-friendly amenities, such as a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2fd3-73b2-954e-1114d82cef46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2fd3-73b2-954e-1114d82cef46",
        "storage_key": "property/6767906449165593/019d7912-2fd3-73b2-954e-1114d82cef46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.livingspaces.com/stores/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15621851924853391165&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "living-spaces",
      "poi_latitude": "35.6066757",
      "poi_longitude": "-97.5652534",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-266-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuacSt-gVsocRPX-juo73y9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_1f2a88a5-09d4-4c13-b8c9-d6e63b03f9f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "13800 N May Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this book store offers a great variety of books, manuals, games, toys, and music, and they appreciate the friendly and helpful staff. They also highlight the clean and well-organized space, making it a comfortable place to browse and relax.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2c6b-75bb-9d4f-ee6d1f1571af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2c6b-75bb-9d4f-ee6d1f1571af",
        "storage_key": "property/6767906449165593/019d7912-2c6b-75bb-9d4f-ee6d1f1571af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2725",
      "poi_directions_map_url": "https://maps.google.com/?cid=4169269107419554585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "35.6111781",
      "poi_longitude": "-97.5664656",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa7GFOmAcsocRGaPA2Ck43Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_b79151c2-cffc-4a27-969e-1dc124b865c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd #1001, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "People say this department store offers a wide selection of merchandise. They also highlight the outstanding customer service and helpful staff.\n\nOther reviews mention the sales people can be pushy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2c20-72d2-909b-373cfe408fdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2c20-72d2-909b-373cfe408fdb",
        "storage_key": "property/6767906449165593/019d7912-2c20-72d2-909b-373cfe408fdb.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.dillards.com/stores/oklahoma/quail-springs-mall-oklahoma-city/0795",
      "poi_directions_map_url": "https://maps.google.com/?cid=18409991828866666490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillard-s",
      "poi_latitude": "35.6134841",
      "poi_longitude": "-97.5574241",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-5220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR-g9xLQduff8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c8000016-b5b0-48bd-b41a-789bc51357aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "13301 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a great selection of groceries and affordable prices. They highlight the good value and clean stores. They also like the kind employees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-2fdc-72df-9880-0a136e10a2a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2fdc-72df-9880-0a136e10a2a1",
        "storage_key": "property/6767906449165593/019d7912-2fdc-72df-9880-0a136e10a2a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/oklahoma-city/13301-n-penn-ave/l795",
      "poi_directions_map_url": "https://maps.google.com/?cid=15333548337638368253&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.605264",
      "poi_longitude": "-97.5505023",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e01f-75cf-9056-8cb3f1eeb13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e01f-75cf-9056-8cb3f1eeb13a",
        "storage_key": "property/6767906449165593/019cfb3b-e01f-75cf-9056-8cb3f1eeb13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVJVDyA134cR_WM38_i0y9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3edd8563-79c7-403a-9989-8c65dbc37f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store carrying a wide range of merchandise, including electronics, home appliances, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, home goods, and electronics, and provides convenient services like delivery and online pickup.\n\nOther reviews mention the service can be slow and the store can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-3636-7532-bdef-3d0848196295.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3636-7532-bdef-3d0848196295",
        "storage_key": "property/6767906449165593/019d7912-3636-7532-bdef-3d0848196295.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1626-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10140810101618845328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6052952",
      "poi_longitude": "-97.5460685",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-752-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-92ec395f5801",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-92ec395f5801.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-WNQUWscsocRkCavIQ9lu4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_17721040-8bd5-452f-9815-f57ad8176ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "AMC Quail Springs Mall 24",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite E, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Recliner-seat theater, in a mall, featuring 3D movies and an IMAX screen.",
      "poi_long_description": "People say this movie theater offers a wide variety of movies, including IMAX and Dolby Digital screenings, and the screens are in good condition. They also highlight the friendly and fast service, and the clean theaters and bathrooms.\n\nOther reviews mention the seats can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-4032-77ca-bd66-772847c89003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4032-77ca-bd66-772847c89003",
        "storage_key": "property/6767906449165593/019d7912-4032-77ca-bd66-772847c89003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-quail-springs-mall-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12403470034805982991&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-quail-springs-mall-24",
      "poi_latitude": "35.6122375",
      "poi_longitude": "-97.5583891",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-7657-7173-8cee-5ce790da77a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-7657-7173-8cee-5ce790da77a0",
        "storage_key": "property/6767906449165593/019d7912-7657-7173-8cee-5ce790da77a0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaQTZ2ccsocRDwfQvkf6Iaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_176e4f78-8761-4911-b173-a84f25c7227b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Quail Creek Golf & Country Club",
      "poi_type": "Entertainment",
      "poi_address": "3501 Quail Creek Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale facility, owned by members, featuring golf courses and tennis courts, plus a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-4179-76c1-be50-b9ab6ced05a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4179-76c1-be50-b9ab6ced05a7",
        "storage_key": "property/6767906449165593/019d7912-4179-76c1-be50-b9ab6ced05a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quailcreekgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160679487445955446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-golf-country-club",
      "poi_latitude": "35.5992235",
      "poi_longitude": "-97.5817331",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdotho8csocRdnMUcj_93Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_acc192f2-6a5a-47c8-8bc5-d40b4f463358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Art Central",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 127, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-43d5-70cf-beac-f71699d02799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-43d5-70cf-beac-f71699d02799",
        "storage_key": "property/6767906449165593/019d7912-43d5-70cf-beac-f71699d02799.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.artcentralok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3721249190432238178&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "art-central",
      "poi_latitude": "35.6124532",
      "poi_longitude": "-97.5572141",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjSacHWMdsocRYmpsNGyIpDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_bd2b20f4-d315-45b6-9c72-06279e1fc7e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Breakout Games",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd #227, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Team-building escape room venue featuring puzzle-filled scenarios and themed challenges.",
      "poi_long_description": "People say this escape room center offers a variety of fun and challenging rooms, including Runaway Train, Kidnapping, and Museum Heist. They highlight the puzzles are varied and have a high level of difficulty, and the rooms are well-decorated and interactive. They also like that the games are designed for private groups, allowing friends and family to play together.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-4a6d-7649-a8dc-37cfed0ac9b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4a6d-7649-a8dc-37cfed0ac9b2",
        "storage_key": "property/6767906449165593/019d7912-4a6d-7649-a8dc-37cfed0ac9b2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.breakoutgames.com/oklahoma-city?utm_source=google&utm_medium=organic&utm_campaign=gmb-oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=1439416862903744307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "breakout-games",
      "poi_latitude": "35.612875",
      "poi_longitude": "-97.557172",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-731-9192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8jzfGccsocRM7cVrQLW-RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_87d65b95-b978-40f3-b12d-67c9e4714cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Louis A. Macklanburg Park",
      "poi_type": "Entertainment",
      "poi_address": "2234 NW 117th St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Community space featuring basketball courts, baseball fields, a splash pad and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-6354-771b-9372-17e40b895eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6354-771b-9372-17e40b895eb5",
        "storage_key": "property/6767906449165593/019d7912-6354-771b-9372-17e40b895eb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2477714902537381353&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "louis-a-macklanburg-park",
      "poi_latitude": "35.5882595",
      "poi_longitude": "-97.5526464",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dff1-722f-85cb-0c7025292312.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dff1-722f-85cb-0c7025292312",
        "storage_key": "property/6767906449165593/019cfb3b-dff1-722f-85cb-0c7025292312.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7bccIkbsocR6aVujJOcYiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ed66a471-8629-4d03-bcf3-6073f522b8c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "Lake Hefner, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5400634991969834440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-hefner",
      "poi_latitude": "35.5769492",
      "poi_longitude": "-97.5768652",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXY-RLXIbsocRyBXoUeno8ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57ac9dbb-72f4-4fe9-8549-2bc992b28586",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "North Britton Park",
      "poi_type": "Entertainment",
      "poi_address": "Oklahoma City, OK 73114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14241348963601168679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-britton-park",
      "poi_latitude": "35.5884029",
      "poi_longitude": "-97.5406333",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-dff1-722f-85cb-0c7025292312.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-dff1-722f-85cb-0c7025292312",
        "storage_key": "property/6767906449165593/019cfb3b-dff1-722f-85cb-0c7025292312.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqnvYbsocRJznTsW1vo8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ef6ae6b5-46a5-4a60-95f3-6a60209d43c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "13600 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Indoor skydiving center flying kids and adults in a vertical wind tunnel, also offering birthday parties and corporate outings.",
      "poi_long_description": "People say this skydiving center offers a thrilling and unforgettable indoor skydiving experience. They highlight the fun, easy, and exciting atmosphere, and the patient, upbeat, and reassuring instructors. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d7912-58ab-71d2-a9b1-a900dd4e82c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-58ab-71d2-a9b1-a900dd4e82c4",
        "storage_key": "property/6767906449165593/019d7912-58ab-71d2-a9b1-a900dd4e82c4.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.iflyworld.com/oklahoma-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13546701854073548325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ifly-indoor-skydiving-oklahoma-city",
      "poi_latitude": "35.607959",
      "poi_longitude": "-97.53839",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-300-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-e009-70cd-98e8-94482684fa8d",
        "storage_key": "property/6767906449165593/019cfb3b-e009-70cd-98e8-94482684fa8d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRw5s2xYcsocRJe4tEpCN_7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_35559619-d9c3-4cb5-89cb-644d0bebe6e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Yokozuna OKC",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "yokozuna-okc",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_854a9357-7007-40b9-83b8-c64d1d58c990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Corner Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "corner-bakery-cafe",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a1760778-a632-4e8c-b42c-c3af1fe980f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Coffee Jerks",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "coffee-jerks",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba593d6e-6626-40a1-b2ea-5c2bf0459763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "poi_name": "Uptown Grocery Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "uptown-grocery-co",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7220057fcf410d32ae7973cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_05d2b758bffe41a1a154d8db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bdb56431be79ca8c2389cb32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_11a9022e383ed80306851a7b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b2b4cdffca72ebb7b2ef2323",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_1fe662e4177ce03fe26ada5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e9f2434f-17a5-4b6d-8404-a5f48613410c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "rating": "5.0",
      "name": "Thelma Herron",
      "text": "I have been a resident in the Chisholm Point Community for over a year. It's been very pleasant. The ladies in the office has always provided an open door. The maintenance crew has been very prompt. The landscaping crew does a wonderful job at keeping our community beautiful. The security is awesome. Nothing in our community goes unnoticed.",
      "date": "2025-04-18",
      "title": ""
    },
    {
      "id": "custom_6f4c04af-918a-4325-b60b-c8c568201ef9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "rating": "5.0",
      "name": "WILLIAM CRAIG",
      "text": "The Chisholm Pointe community is an awesome place to live. There are a variety of floor plans to accommodate different lifestyles and needs. The management is immediately responsive to any questions, needs or concerns. The maintenance team responds quickly and does excellent work.\nWe recommend Chisholm Pointe without reservation.\nAlso, the community has a beautiful look. The builders went the extra mile to make this a pleasant place to call home. Love all the trees!\nFriends love the pool, pickleball court and two dog parks.\nWe hope you come join our community!",
      "date": "2025-04-16",
      "title": ""
    },
    {
      "id": "custom_6b28157c-0931-4deb-b6bd-4f3d077b0ffd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "rating": "5.0",
      "name": "Muscle Bound Movers",
      "text": "These are brand new apartments and what's unique about them is that they are built like homes. They have great access to and from each property making it super easy to move in and out. It's a gated community in an excellent location of town...",
      "date": "2024-02-05",
      "title": ""
    },
    {
      "id": "custom_be78d7b3-0d7a-4520-8d05-ab95320e4e8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "rating": "5.0",
      "name": "Joanna Lee",
      "text": "My family and I moved in back in October of 2024. We’ve had nothing less than a great experience thus far from the management team. Any maintenance requests/issues we may have had, get taken care of in a speedy manner.\nWhat we love the most is the layout options as well as hard surface flooring throughout! Including bedrooms & closets, which are hard to come by.\n\nAnd additional perks?? Location!! In a quiet area, within close proximity to shopping and highway/tnpk.\n\nNeighbors have been friendly and the community overall is a peaceful vibe!\n\nThanks Chisolm Pointe!",
      "date": "2025-04-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bb785cb5-6a5a-4321-9b7e-9f552af024e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3d-012d-76cd-95d1-303ceedeab52.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a kitchen and living area with modern farmhouse decor",
        "public_id": "019cfb3d-012d-76cd-95d1-303ceedeab52",
        "storage_key": "property/6767906449165593/019cfb3d-012d-76cd-95d1-303ceedeab52.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Chisholm Pointe Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6965bca040714d17cae3fbc3&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-233d-707f-879e-919345434142",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "chisholm-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593"
    },
    {
      "lead_collector_id": "019cf79e-23b1-70bd-9572-4d22b3a80adb",
      "lead_source": "LANDING_PAGE",
      "name": "chisholm-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-dog-park-oklahoma-city",
      "search_query": "apartments with an onsite dog park in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Onsite Dog Park in OKC",
      "h2_subtitle": "Looking for apartments with an onsite dog park in Oklahoma City? Discover Chisholm Pointe and enjoy pet-friendly living in Northwest OKC.",
      "page_copy": "At Chisholm Pointe in Oklahoma City, you and your furry friend will feel right at home. Our apartments with an onsite dog park in Oklahoma City offer everything needed for a vibrant lifestyle. Choose from spacious one, two, or three-bedroom units with modern amenities like energy-efficient appliances and in-unit washer and dryer connections.\n\nBeyond your front door, enjoy the perks of living at Chisholm Pointe, including a refreshing resort-style swimming pool and a pickleball court. With preinstalled WiFi by Cox, staying connected is easy. Visit us today and see why we're the best choice for dog-friendly living in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Onsite Dog Park in OKC",
      "seo_description": "Find pet-friendly apartments with an onsite dog park in Oklahoma City at Chisholm Pointe. Enjoy modern amenities and vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-stainless-appliances-nw-okc",
      "search_query": "energy-efficient apartments with stainless appliances northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartments in NW OKC",
      "h2_subtitle": "Discover energy-efficient apartments with stainless appliances in Northwest Oklahoma City. Find your modern home at Chisholm Pointe today.",
      "page_copy": "Embrace modern living at Chisholm Pointe, where our energy-efficient apartments with stainless appliances in Northwest Oklahoma City offer the perfect blend of style and sustainability. Choose from spacious floor plans including one, two, or three-bedroom options that are designed to make your life comfortable and convenient.\n\nLocated in a vibrant community, Chisholm Pointe features amenities such as resort-style swimming pools, pickleball courts, and fenced yards. Enjoy the convenience of package receiving and preinstalled WiFi modems, ensuring you stay connected. Visit Chisholm Pointe and experience the best in contemporary living today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartments in NW OKC",
      "seo_description": "Explore energy-efficient apartments with stainless appliances in NW Oklahoma City at Chisholm Pointe. Modern living with top amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-oklahoma-city-73120",
      "search_query": "resort-style pool apartments in Oklahoma City 73120",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in OKC 73120",
      "h2_subtitle": "Discover resort-style pool apartments in Oklahoma City, 73120. Dive into luxury living at Chisholm Pointe with top-notch amenities.",
      "page_copy": "Dive into luxury at Chisholm Pointe's resort-style pool apartments in Oklahoma City, 73120. Enjoy our serene outdoor spaces and choose from our spacious one, two, or three-bedroom apartments. Each unit is designed with modern living in mind, featuring energy-efficient appliances and ample living space.\n\nRelax by the pool or enjoy a game at our pickleball court. Our community also includes a clubhouse, dog park, and a fenced yard, perfect for pet owners. With preinstalled WiFi modems powered by Cox, staying connected is a breeze. Visit us today and see why Chisholm Pointe is the top choice for high-end living in northwest OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in OKC 73120",
      "seo_description": "Find resort-style pool apartments in OKC, 73120 at Chisholm Pointe. Enjoy luxurious living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-near-pickleball-courts-nw-okc",
      "search_query": "apartments near pickleball courts in NW OKC",
      "category": "Amenity",
      "h1_title": "Apartments Near Pickleball Courts in NW OKC",
      "h2_subtitle": "Looking for apartments near pickleball courts in NW OKC? Chisholm Pointe offers vibrant living with easy access to recreational activities.",
      "page_copy": "Elevate your lifestyle at Chisholm Pointe, where our apartments near pickleball courts in NW OKC provide a perfect balance of fun and comfort. Our community features spacious one, two, and three-bedroom options with modern amenities like energy-efficient appliances and convenient in-unit washer and dryer connections.\n\nResidents at Chisholm Pointe enjoy a vibrant community atmosphere with a resort-style swimming pool, onsite dog park, and more. Take advantage of our preinstalled WiFi modems powered by Cox, ensuring seamless connectivity. Join us and experience the benefits of living close to top recreational activities in northwest Oklahoma City. Tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pickleball Courts in NW OKC",
      "seo_description": "Discover Chisholm Pointe's apartments near pickleball courts in NW OKC. Enjoy vibrant living with top amenities and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "gated-apartments-wood-style-flooring-oklahoma-city",
      "search_query": "gated apartments with wood style flooring in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Gated Apartments with Wood Style Flooring",
      "h2_subtitle": "Discover gated apartments with wood style flooring in Oklahoma City. Find your stylish new home at Chisholm Pointe today.",
      "page_copy": "Chisholm Pointe offers exquisite gated apartments with wood style flooring in Oklahoma City, blending elegance with modern convenience. Our spacious one, two, and three-bedroom apartments are designed to suit your lifestyle, featuring energy-efficient appliances and ample living space.\n\nEnjoy privacy and security in our gated community, complete with resort-style amenities including a swimming pool, dog park, and pickleball court. Each apartment is equipped with washer and dryer connections and preinstalled WiFi modems. Experience refined living at Chisholm Pointe, where comfort meets style in a vibrant community setting. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apartments with Wood Style Flooring",
      "seo_description": "Explore gated apartments with wood style flooring in Oklahoma City at Chisholm Pointe. Modern living with premium features awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-northwest-oklahoma-city",
      "search_query": "two bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Northwest OKC",
      "h2_subtitle": "Explore spacious two bedroom apartments in Northwest Oklahoma City. Enjoy the perfect blend of comfort and convenience at Chisholm Pointe.",
      "page_copy": "Discover the ideal living space with Chisholm Pointe's two bedroom apartments in Northwest Oklahoma City. Designed to meet modern needs, these spacious units feature energy-efficient appliances and inviting interiors, perfect for creating a cozy home. Whether you work from home or entertain guests, the layout offers flexibility and style.\n\nAs part of our vibrant community, you'll have access to fantastic amenities such as a resort-style swimming pool, a pickleball court, and a dog park. Additional conveniences include preinstalled WiFi modems powered by Cox and easy package receiving services. Come see the benefits of living in a thriving neighborhood today at Chisholm Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Northwest OKC",
      "seo_description": "Find two bedroom apartments in Northwest Oklahoma City at Chisholm Pointe. Modern amenities and a vibrant community await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-okc",
      "search_query": "one bedroom apartments okc",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in OKC",
      "h2_subtitle": "Check out our one bedroom apartments in OKC, offering modern living with top amenities. Chisholm Pointe has the perfect home for you.",
      "page_copy": "Chisholm Pointe provides stylish one bedroom apartments in OKC, perfect for those seeking a modern urban lifestyle. Our well-designed units feature energy-efficient appliances and spacious layouts ideal for singles or couples. The blend of convenience and comfort ensures that every resident enjoys a remarkable living experience.\n\nJoin a welcoming community equipped with resort-style amenities like a sparkling swimming pool, a dog park, and a state-of-the-art pickleball court. Enjoy seamless connectivity with preinstalled WiFi modems by Cox. Located in the heart of Oklahoma City, Chisholm Pointe offers the best in urban living without compromising on tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in OKC",
      "seo_description": "Discover one bedroom apartments in OKC at Chisholm Pointe. Enjoy modern amenities and a lively community in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-73120",
      "search_query": "three bedroom apartments near 73120",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 73120",
      "h2_subtitle": "Find spacious three bedroom apartments near 73120 in Oklahoma City. Chisholm Pointe offers room for families and groups to flourish.",
      "page_copy": "Chisholm Pointe presents exceptional three bedroom apartments near 73120, tailored for families or roommates seeking ample living space. Our thoughtfully designed homes come with modern amenities like energy-efficient appliances and washer & dryer connections, ensuring convenience and comfort.\n\nLocated in a vibrant community setting, residents can enjoy a range of amenities including a resort-style swimming pool, a fun pickleball court, and a secure dog park. The gated community provides peace of mind, while easy access to major city attractions enhances your lifestyle. Experience the perfect blend of location and luxury today at Chisholm Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 73120",
      "seo_description": "Explore three bedroom apartments near 73120 at Chisholm Pointe. Spacious homes with modern amenities in a prime OKC location await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-near-oklahoma-christian-university-nw-okc",
      "search_query": "apartments near oklahoma christian university northwest oklahoma city",
      "category": "School",
      "h1_title": "Apartments Near Oklahoma Christian University",
      "h2_subtitle": "Discover our apartments near Oklahoma Christian University in Northwest Oklahoma City. Enjoy a community that blends convenience with comfort.",
      "page_copy": "Located conveniently near Oklahoma Christian University, Chisholm Pointe offers the ideal apartments for students and faculty seeking a vibrant yet tranquil living environment in Northwest Oklahoma City. Choose from an array of one, two, or three-bedroom layouts equipped with modern amenities such as energy-efficient appliances and preinstalled Wi-Fi modems powered by Cox.\n\nOur community features a resort-style swimming pool, a dynamic pickleball court, and a spacious dog park, making it an enjoyable place to call home. Plus, with easy access to university facilities and local attractions, you'll find the perfect balance between academic and leisurely pursuits at Chisholm Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oklahoma Christian University",
      "seo_description": "Find apartments near Oklahoma Christian University at Chisholm Pointe, where modern living meets prime convenience in Northwest OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Baptist",
      "h2_subtitle": "Find comfortable apartments near INTEGRIS Health Baptist Medical Center in Oklahoma City. Chisholm Pointe offers convenience and modern amenities.",
      "page_copy": "For those seeking apartments near INTEGRIS Health Baptist Medical Center in Oklahoma City, Chisholm Pointe is the perfect choice. Our community offers one, two, and three-bedroom apartments equipped with contemporary features like energy-efficient appliances and Wi-Fi modems by Cox, ensuring a hassle-free living experience.\n\nResidents enjoy a variety of amenities including a resort-style swimming pool, package receiving services, and fenced yards for extra privacy. Located just a short drive from the medical center, Chisholm Pointe is ideal for healthcare professionals and patients who need quick access to top medical facilities without compromising on the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Baptist Medical",
      "seo_description": "Discover Chisholm Pointe's apartments near INTEGRIS Health Baptist Medical Center OKC, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-close-to-mercy-hospital-okc",
      "search_query": "apartments close to Mercy Hospital OKC",
      "category": "Hospital",
      "h1_title": "Apartments Close to Mercy Hospital OKC",
      "h2_subtitle": "Discover apartments conveniently close to Mercy Hospital in OKC. Chisholm Pointe offers a blend of comfort and prime location.",
      "page_copy": "Chisholm Pointe is an excellent option for those looking for apartments close to Mercy Hospital in Oklahoma City. Our community features generously sized one, two, and three-bedroom apartments, ideal for healthcare professionals and hospital visitors alike. Enjoy modern amenities such as energy-efficient appliances and in-unit washer & dryer connections for added convenience.\n\nBeyond the comfort of your apartment, indulge in our community offerings including a refreshing resort-style swimming pool and a lively pickleball court. Situated within a short drive to Mercy Hospital, Chisholm Pointe combines accessibility with a welcoming neighborhood atmosphere, making it a top choice in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mercy Hospital OKC",
      "seo_description": "Find comfortable living at Chisholm Pointe, close to Mercy Hospital OKC. Experience modern convenience and easy access today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-okc",
      "search_query": "apartments near Martin Park Nature Center Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center OKC",
      "h2_subtitle": "Explore our cozy apartments near Martin Park Nature Center in Oklahoma City. Enjoy convenient access and a serene living environment.",
      "page_copy": "Nestled close to Martin Park Nature Center, Chisholm Pointe offers the perfect homes for nature lovers and those appreciating tranquility in Oklahoma City. Our one, two, and three-bedroom apartments feature modern touches like energy-efficient appliances and spacious living areas, perfect for relaxing after a day spent in nature.\n\nResidents can soak up the community vibe with our resort-style pool and outdoor living spaces, or venture out to the nearby Martin Park Nature Center for leisurely walks and wildlife viewing. Conveniently located, Chisholm Pointe provides easy access to both natural beauty and urban amenities, making it the ideal place to settle in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Martin Park Nature Center",
      "seo_description": "Live near Martin Park Nature Center at Chisholm Pointe, offering modern apartments with easy access to OKC's natural and urban attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "rentals-close-to-will-rogers-gardens-okc",
      "search_query": "rentals close to Will Rogers Gardens OKC",
      "category": "Park",
      "h1_title": "Rentals Close to Will Rogers Gardens OKC",
      "h2_subtitle": "Discover charming rentals close to Will Rogers Gardens in Oklahoma City. Chisholm Pointe blends convenience with inviting living spaces.",
      "page_copy": "Positioned conveniently close to Will Rogers Gardens, Chisholm Pointe in Oklahoma City offers ideal rentals for those seeking a balance of green spaces and urban living. Choose from our well-appointed one, two, and three-bedroom apartments featuring high-efficiency appliances and ample outdoor spaces that provide comfort and relaxation.\n\nResidents enjoy a slew of amenities, including a refreshing resort-style swimming pool and dog-friendly areas, perfect for pet lovers. Situated just a short drive from Will Rogers Gardens, Chisholm Pointe provides easy access to beautiful floral displays and walking trails, blending natural beauty with modern living in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Will Rogers Gardens OKC",
      "seo_description": "Chisholm Pointe rentals nearby Will Rogers Gardens offer modern living with easy access to OKC's lush parks and urban conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "apartments-near-stars-and-stripes-park-okc",
      "search_query": "apartments near Stars and Stripes Park in Northwest Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Stars and Stripes Park OKC",
      "h2_subtitle": "Enjoy lively living at apartments near Stars and Stripes Park in Northwest Oklahoma City. Find comfort and convenience at Chisholm Pointe.",
      "page_copy": "Chisholm Pointe offers an enticing option for those looking to settle near Stars and Stripes Park in Northwest Oklahoma City. Our spacious one, two, and three-bedroom apartments are designed with modern amenities, ensuring a comfortable lifestyle close to one of OKC's vibrant parks. Enjoy energy-efficient appliances, serene outdoor spaces, and an inviting community setting.\n\nTake advantage of our on-site features like a resort-style swimming pool and pickleball court, while appreciating being a short distance from the recreational activities at Stars and Stripes Park. Chisholm Pointe combines accessibility and leisure, making it the perfect place for both active lifestyles and relaxation in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Stars and Stripes Park OKC",
      "seo_description": "Chisholm Pointe offers stylish apartments near Stars and Stripes Park in OKC, combining modern living with convenient park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165593",
      "source": "generator",
      "page_item_url": "bluff-creek-park-nearby-apartments-73120",
      "search_query": "Bluff Creek Park nearby apartments in 73120",
      "category": "Park",
      "h1_title": "Bluff Creek Park Nearby Apartments in 73120",
      "h2_subtitle": "Find your ideal home with Bluff Creek Park nearby. Our apartments in the 73120 area offer great amenities and easy park access.",
      "page_copy": "Located in the 73120 area, Chisholm Pointe provides a prime living experience for those looking to be near Bluff Creek Park, a haven for outdoor enthusiasts. Choose from our selection of one, two, or three-bedroom apartments, each boasting modern features like energy-efficient appliances and spacious layouts, perfect for enjoying a comfortable lifestyle.\n\nWith convenient amenities, such as a resort-style pool and a dog park, residents can easily blend relaxation with an active routine. Whether you're biking the trails of Bluff Creek Park or lounging at our poolside, our community ensures you have everything you need to enjoy life in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern single-story apartment building with teal siding and a covered parking area.",
        "public_id": "019cfb3b-b671-74cd-98b4-a71e268d08ff",
        "storage_key": "property/6767906449165593/019cfb3b-b671-74cd-98b4-a71e268d08ff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bluff Creek Park Nearby Apartments 73120",
      "seo_description": "Live near Bluff Creek Park in the 73120 area at Chisholm Pointe, offering comfort and modern amenities alongside natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5156"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-018PY3EYMZ"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151891"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/chisholm-pointe/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TBSHX4LF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165593/019d1bd6-3949-741d-b78a-ec9efde2a5a3.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-827-0027"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "69f9341aec06818df8f511ca"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkpRVVpPT2pmdVg1MitDVExUMzNOV0E9PSIsInZhbHVlIjoibEp3MEJWa2lXeXJ3V3BuakZYTEdsUT09IiwibWFjIjoiM2FkZTFhZjZjODc2YjY2ODdiZjcxMWZkYzE0NjBlNmUyMDMxZmI5NmJlN2Y1OTE1MzNmMDU0NmMyZjdmYzExNSJ9"
    }
  ],
  "custom_qb_id": "5156",
  "custom_ga4_id": "G-018PY3EYMZ",
  "custom_repli_id": "10041151891",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/chisholm-pointe/register/",
  "custom_google_gtm_id": "GTM-TBSHX4LF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165593/019d1bd6-3949-741d-b78a-ec9efde2a5a3.pdf",
  "custom_ppc_tracking_phone_number": "866-827-0027",
  "custom_residentboost_apartment_id": "69f9341aec06818df8f511ca",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkpRVVpPT2pmdVg1MitDVExUMzNOV0E9PSIsInZhbHVlIjoibEp3MEJWa2lXeXJ3V3BuakZYTEdsUT09IiwibWFjIjoiM2FkZTFhZjZjODc2YjY2ODdiZjcxMWZkYzE0NjBlNmUyMDMxZmI5NmJlN2Y1OTE1MzNmMDU0NmMyZjdmYzExNSJ9"
};

export const generatedAt = '2026-08-27T21:39:14.116Z';
